import Cookies from 'js-cookie';
// import Raven from 'raven-js';
import _ from 'lodash'
import Debug from 'debug';
import Tether from 'tether';
import { SASubjectiveFeedbackHandler } from './activities/short-answer';
import {
  RecordSCORMinteraction,
  RecordTest,
  setupSCORM,
} from './scormfunctions.js';
import './elementRearrangement';
import './clickThroughSequence';
import './carousel';
import './tabs';
import './accordion';
import './modal';
import './advSlider';
import './scenes';
import './hotspots';
import './spaced';
import './matching';
import './jquery.ui.labeledslider';
import './shortanswer';
import './utils';
import './popup';
import './playlist';
import './pushnotify/push';
import './ipa-modal-progress';
import './navigation-sidebar';
import './navigation-hamburger';
import './exportHTMLtoPdf'
const loDebug = Debug('gh:lobuilder');
const debug = loDebug;
window.loDebug = loDebug;

window.Cookies = Cookies;
setupSCORM();
if (/.+\.sproutlabs\.com\.au/g.test(window.location.href)) {
  window.DEBUGGING = false;
} else window.DEBUGGING = true;
(function($) {
  $(document).ready(function() {
    if (window.Raven) {
      // webpack replaces _VERSION with CI_BUILD_REF at build time
      if (process.env.NODE_ENV === 'production') {
        // window.Raven.config('https://329954dcfd2541519525acae173f0cd8@sentry.io/142232', { release: _VERSION }).install(); // eslint-disable-line no-undef
        window.Raven.setUserContext({
          email: window.glasshouseEmail,
        });
        window.Raven.setRelease(_VERSION); // eslint-disable-line no-undef
      } else {
        window.Raven.setRelease('development'); // eslint-disable-line no-undef
      }
    }
    if (window.DEBUGGING) {
      const ids = {};
      let found = false;
      $('[id]').each(function() {
        if (this.id && ids[this.id]) {
          found = true;
          console.error(`Duplicate ID #${this.id}`);
        }
        ids[this.id] = 1;
      });
    }

    // console.log("Testing for hotfix")
    $(window).bind('pageshow', function() {
      // update hidden input field
     
      $('.js__page__loading').hide(); // show the loading screen because wait has to happen.
      $('.js__page__loading_spinner').removeClass('fa-spin');
      const xapi = $('.xApiFormWrapper');
      const checkIfExist = $('.formElement');
      if (xapi && xapi.length > 0 && checkIfExist.length < 1) {
        $('.js__page__loading').show(); // show the loading screen because wait has to happen.
        $('.js__page__loading_spinner').addClass('fa-spin');
      }
      if (!window.APIGATEWAY){
        $('.js__page__loading').hide();
        $('.js__page__loading_spinner').removeClass('fa-spin');
      }


    });

    // Only the text currently has the link on it. This triggers the link when the box is pressed
    $('body').on('click', '.js__holder_page__pages_page', e => {
      const childLink = $(e.currentTarget).find('a');
      if (childLink.length > 0) window.location = $(childLink[0]).attr('href');
    });

    /* modified: https://coderwall.com/p/uf2pka */
    // make the first slide of any branching scenarios visible
    $('.firstslide').show();
    // responsive image map
    $('img[usemap]').rwdImageMaps();

    // create hidden links to all video asset files so that wget can find them when creating SCORM objects
    makeSCORMlinks();
    $('#deleteCommentAlert').hide();
    if ($().easytabs) {
      if ($('.childrenAsTabs > ul > li').length > 0) {
        // easytabs doesn't work with older versions of jquery

        // Return to default behavior of scrolling to anchor if the class `js__children__tabs__scrolling` is applied to a child block.
        // You can do this here: http://localhost:52194/admin/pages/edit/EditForm/xxx/field/Activities/item/xxx under extra css classes for all blocks
        var childrenAsTabs = $('.childrenAsTabs');
        var layoutBlockHolder = childrenAsTabs.parent();
        if ((layoutBlockHolder && (layoutBlockHolder.length > 0)) && layoutBlockHolder.hasClass('js__children__tabs__scrolling')) {
          // Default is updateHash: true, see: https://os.alfajango.com/easytabs/#available-options
          childrenAsTabs.easytabs();
        } else {
          childrenAsTabs.easytabs({ updateHash: false });
        }

      } else if ($(`${$('.childrenAsTabs').data('tabloc')} > ul > li`).length) {
        $($('.childrenAsTabs').data('tabloc'))
          .easytabs({ panelContext: $(document), animate: false })
          .bind('click', function(e) {
            e.preventDefault();
          });
      }
    }

    // count of all activites (on sequence pages and in modal dialogs)
    window.activitiesOnPage = $('.isActivity').length;
    // console.log("found "+window.activitiesOnPage+" activities on the page");
    window.SelectedPlan = {};
    window.SelectedActivity = {};
    // $.removeCookie('finalscore', {path: "/"});

    // indicate the existance of the total score

    Cookies.set('triggerclass', [], {
      expires: 7,
      path: '/',
    });
    if (Cookies.get('finalscore')) {
      if ($('.ResetFinalScore').length > 0) {
        Cookies.set('finalscore', 0, {
          expires: 7,
          path: '/',
        });
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
          if (ca[i].substr(ca[i].length - 12) == 'QuestionDone') {
            const cookieName = ca[i].slice(0, -13);
            Cookies.set(cookieName.replace(' ', ''), null, {
              expires: 1,
              path: '/',
            });
          }
        }
      }
      $('.finalscore').text(Cookies.get('finalscore'));
      if ($('.overallFeedbackButton').length > 0) {
        $('.overallFeedbackButton').show();
      } else if ($('.showWhenOnLoad').length > 0) {
        showFeedbackRange($('body'));
      } else if ($('.showWhenClassClick').length > 0) {
        const triggerclass = $.map($('.showWhenClassClick'), $.text); // Handles multiple as an array
        // var triggerclass = '.' + $('.showWhenClassClick').text();

        Cookies.set('triggerclass', triggerclass, { expires: 7, path: '/' });
      }

      $('.EmptyScore').hide();
    } else {
      window.totalscore = 0;
      $('.finalscore').text('0');
    }

    // this cookie store the score of every question
    // if (Cookies.get('scoreAll')) {
    //
    // }

    // track activity in a worked example
    window.currentscore = 0; // for self assessment scoring
    // window.totalscore = 0; // for self assessment scoring

    $.removeCookie('currentpage', {
      path: '/',
    });



    const shortUrl = window.location.pathname;
    const pattern = '/';
    const re = new RegExp(pattern, 'g');
    const currentPage = shortUrl.replace(re, '');
    // alert(currentPage);
    window.currentTab = `lasttab-${currentPage}`;
    window.currentCookie = `lastscene-${currentPage}`;

    const imagemapManager = new ImageMapManagerFn();
    imagemapManager.registerHandlers();

    const actionManager = new ActionManagerFn();
    actionManager.registerHandlers();

    const feedbackManager = new FeedbackManagerFn();
    feedbackManager.registerHandlers();

    const stateManager = new StateManagerFn();
    stateManager.registerHandlers();

    const draganddropManager = new DragandDropManagerFn();
    draganddropManager.registerHandlers();

    const tableManager = new TableManagerFn();
    tableManager.registerHandlers();

    const loBuilderManager = new LoBuilderManagerFn();
    loBuilderManager.registerHandlers();

    const clozeTestManager = new ClozeTestManagerFn();
    clozeTestManager.registerHandlers();

    const dropDownManager = new DropDownManagerFn();
    dropDownManager.registerHandlers();

    const rangeSliderManager = new RangeSliderManagerFn();
    rangeSliderManager.registerHandlers();

    const matchingPairManager = new MatchingPairManagerFn();
    matchingPairManager.registerHandlers();

    const bandwidthManager = new BandwidthManagerFn();
    bandwidthManager.registerHandlers();

    $(document).keypress(this.keyPressed);
    // Tutorial.prototype.keyPressed = function(event) {
    //     event.preventDefault();
    // }

    // click or press enter to do search
    $('#SearchForm_SearchForm_Tags').keypress(event => {
      if (event.keyCode == 13) {
        $('#SearchForm_SearchForm_action_doSearch').click();
      }
    });
    let name = '';
    if (Cookies.get('learnername')) {
      name = Cookies.get('learnername');
      $('.learnerinput').hide();
    }

    // begin of my plan feature
    // My plan

    // remove plan
    /* $('.rmPlan').on('click', function(e) {
            $(this).closest('.accordion-group').remove();
            var planindex = Cookies.getJSON('planindex');
            var indexKeys = Object.keys(planindex);
            var indexlen = indexKeys.length;
            var planKey = $(this).siblings('a').html();
            var actualindex;
            for (var i = 1; i <= indexlen; i++) {
                $.each(Cookies.getJSON('plan' + i), function(key, value) {
                    if (key == planKey) {
                        $.removeCookie('plan' + i, {
                            path: "/"
                        });
                        actualindex = i;
                        i = parseInt(indexlen, 10) + 1;
                    }
                });
            }
            for (var j = actualindex; j <= indexlen; j++) {
                var nextindex = parseInt(j, 10) + 1;
                Cookies.set('plan' + j, Cookies.get('plan' + nextindex), {
                    expires: 7,
                    path: '/'
                });
            }
            delete planindex[parseInt(indexlen, 10) - 1];
            Cookies.set('planindex', JSON.stringify(planindex), {
                expires: 7,
                path: '/'
            });
            $.removeCookie('plan' + indexlen, {
                path: "/"
            });
        }); */

    // add tooltips
    let inTooltip = false;
    // $('a[title]').qtip();
    // $('.tooltipAction').tooltip({html: 'true', placement: 'bottom', trigger: 'manual'}).click(function(e) {

    // if ($.browser.msie && parseInt($.browser.version, 10) < 10) {
    //     $('.tooltipAction').tipsy({
    //         html: true
    //     });
    //     //console.log('yes its IE8 or 9');
    // }

    // add new code display alt info in tooltip
    $('area[href^="tooltip"]').qtip({
      show: 'click',
      hide: 'click',
      content: {
        text: $(this).alt,
      },
      position: {
        target: 'mouse',
        adjust: {
          mouse: true,
        },
      },
      style: 'qtip-bootstrap qtip-rounded myQtipCustomStyle',
    });

    let tt = false;

    // Means we can just use HTML markup
    $('[data-toggle="tooltip"]').tooltip();

    $('.tooltipAction')
      .tooltip({
        html: true,
        // placement: 'bottom',
        placement(tip, element) {
          // $this is implicit
          if ($(element).data('placement') != null) {
            return $(element).data('placement');
          } else {
            const width = $(element).width();
            if (
              width < 450 &&
              $(element)
                .parent()
                .width() > 500
            ) {
              return 'right';
            } else {
              return 'bottom';
            }
          }
        },
        trigger: 'manual',
      })
      .click(function(e) {
        if ($(this) != tt && tt) {
          // if we have an open tooltip, and we click on another, close the open one.
          tt.tooltip('hide');
          e.preventDefault();
          e.stopPropagation();
          $(this).tooltip('show');
          inTooltip = true;
          tt = $(this);
          e.preventDefault();
          e.stopPropagation();
        } else if (inTooltip == false) {
          // $(this).tooltip('show');
          // jQuery.offset(); // this might have fixed the 'tooltip not displaying in IE9' problem, but when using tipsy worked I didn't investigate it any further (see https://github.com/twitter/bootstrap/issues/6689) P

          e.preventDefault();
          e.stopPropagation();
          $(this).tooltip('show');
          inTooltip = true;
          tt = $(this);
          e.preventDefault();
          e.stopPropagation();
        } else {
          // if we click on an open tooltip, close it
          // console.log('touch the tooltip');
          // e.preventDefault();
          // e.stopPropagation();
          // $(this).tooltip('hide');
          // inTooltip = false;
          // tt = false;
          // e.preventDefault();
          // e.stopPropagation();
        }
      });
    // when the document is clicked, hide any tooltips that are open
    $('body').bind('click touch', e => {
      // console.log('just clicked on the document ');
      if (inTooltip == true) {
        inTooltip = false;
        e.preventDefault();
        e.stopPropagation();
        if (tt != false) {
          tt.tooltip('hide');
          tt = false;
          e.preventDefault();
          e.stopPropagation();
        }
      }
    });

    // set up any branching scenarios on the page
    BranchingActivitySetup($(this));

    // tidy up the visual display of tooltip's with for images.

    $('.tooltipAction img')
      .parent()
      .css('background-color', 'white');
    $('.tooltipAction img')
      .parent()
      .css('padding', '0px');

    $('.tooltipAction img')
      .parent()
      .css('background-image', 'none');

    // add tooltips to activity tracker areas
    $('.trackcircle').tooltip({
      placement: 'bottom',
    });

    // Bind the event.
    // $(window).hashchange(function() {
    //     //console.log('hashchanged: '+location.hash.substr(1)+ ' pathname: '+location.pathname+location.hash);
    //     //debugger;
    //     var hash = window.location.hash;
    //     // opening another tab
    //     $('.modal').modal('hide'); // close any open modal dialogs (this for when a link to a tab is clicked on from inside a modal)
    //     $(this).scrollTop(0); // stop the page jumping around as each tab is clicked on
    //     $('#Sections a[href="' + location.pathname + location.hash + '"]').tab('show');
    //
    // })

    // Trigger the event (useful on page load).
    // $(window).hashchange();

    // $(".modal").resizable();
    // $(".modal").draggable();
    // console.log('inital enabled draggable');

    $('body').on('shown', '.modal', function() {
      // initialise any branching activity
      BranchingActivitySetup($(this));
      /* update the activity tracker whenever a modal activity is closed */
      // console.log('#activity'+$(this).attr("id"));
      $(`#activity${$(this).attr('id')}`).removeClass('tracknotdone');
      $(`#activity${$(this).attr('id')}`).addClass('trackdone');
      // add some indication that this was the last activity attempted so that it's easier to return to it
      // first, remove any existing marker
      $('.trackcircle').each(function(index) {
        // console.log( index + ": " + $(this).find(">:first-child").html() );
        $(this)
          .find('>:first-child')
          .html('&nbsp;&nbsp;&nbsp;&nbsp;');
      });
      // now add some visual feedback to our current dot - IP releated
      $(`#activity${$(this).attr('id')}`)
        .find('>:first-child')
        .html('&bull;&nbsp;');
      // set a cookie so we can return here if the back icon in the toolbar (<) is clicked
      Cookies.set('currentactivity', `#${$(this).attr('id')}`, {
        expires: 7,
        path: '/',
      });
      // track progress for SCORM
      let modalActivitiesDone = Array();
      if (Cookies.get('modalActivitiesDone') != null) {
        modalActivitiesDone = Cookies.getJSON('modalActivitiesDone');
      }
      // console.log('modalActivitiesDone cookie: '+Cookies.getJSON('modalActivitiesDone')+' modalActivitiesDone: '+modalActivitiesDone);
      const found = $.inArray($(this).attr('id'), modalActivitiesDone);
      if (found < 0) {
        // this is the first time we've done this activity
        // record that the activity is completed
        modalActivitiesDone.push($(this).attr('id'));
        // console.log('modalActivitiesDone: '+modalActivitiesDone);
        Cookies.set('modalActivitiesDone', modalActivitiesDone, {
          expires: 7,
          path: '/',
        });
        const title = $('#pagetitle')
          .text()
          .replace(/[^a-zA-Z0-9]/g, '_');
        // SCORM is now being tracked on an activity by activity basis so that we can track progress on sequence pages too (PS 10 Nov 2014)
        // // update SCORM score
        // //console.log('Score now: '+score);
        // activityname = $('#myModalLabel' + $(this).attr("id").replace('_modal', '')).text() + " - " + $('#pagetitle').text();
        // //activitynum = $('#activity' + $(this).attr("id")).attr("activitynum"); // no longer needed, we're getting this from the lms now
        // RecordTest(score, activityname);

        // stash progress in a cookie so we can show it on the main page menu
        if (typeof Cookies.get(`${title}_ActivitesCompleted`) === 'undefined') {
          Cookies.set(`${title}_ActivitesCompleted`, 1, {
            expires: 7,
            path: '/',
          }); // for tracking completed worked examples
        } else {
          Cookies.set(
            `${title}_ActivitesCompleted`,
            parseInt(Cookies.get(`${title}_ActivitesCompleted`)) + 1,
            {
              expires: 7,
              path: '/',
            },
          );
        }
      } else {
      }
      // // re-open the active tab for this activity
      // $('#Sections a[href="' + activeTab + '"]').tab('show');
      // stop any video currently playing in the now closed modal
      if (window.playerloaded == 'yes') {
        jwplayer().stop();
        window.playerloaded == 'no';
      }
    });

    // check to see if we need to re-open an activity (eg when the back icon in the toolbar (<) is clicked)
    if (
      Cookies.get('currentactivity') != '' &&
      $(Cookies.get('currentactivity')).length
    ) {
      $(Cookies.get('currentactivity')).modal('show');

      if ($(Cookies.get('currentactivity')).find('.nav-tabs').length > 0) {
        const href = document.location.toString();
        if (!href.match('#'))
          $(`${Cookies.get('currentactivity')} a:first`).tab('show');
      }
    }

    // set up a global variable to alert the system that a handbook link has been clicked on from an activity
    $('.HandBookLink').click(function() {
      // console.log($(this).parent().parent().attr("id"));
      // console.log($(this).closest('.modal').attr("id"));
      Cookies.set(
        'currentactivity',
        `#${$(this)
          .closest('.modal')
          .attr('id')}`,
        {
          expires: 7,
          path: '/',
        },
      );
      // $('.modal').modal('hide'); no longer needed since handbook links are opening in a new tab
    });

    $('.nav-tabs').click(() => {
      // clear the global variable for alert the system that a handbook link has been clicked when any tab is clicked on or when a modal is closed
      Cookies.set('currentactivity', '', {
        expires: 7,
        path: '/',
      });
      // reset activities
      $('.Feedback').hide();
      $('.Response').show();
      $('.ShortAnswerFeedback').show();
      $('input').attr('checked', false);

      $('.ui-widget-content').show();
      $('.DnDanswers').html(
        '<li class="placeholder">Drop your paragraphs here<br><br><br></li>',
      );
      $('.showDnDfeedback').show();
      $('.hideDnDfeedback').hide();
      $('.wasFeedback').addClass('Feedback');
      $('.DnDsource .Feedback').removeClass(
        'alert-success alert-error wasFeedback',
      );
      $('.DnDtarget .Feedback').removeClass(
        'alert-success alert-error wasFeedback',
      );
    });

    // force all modals to close
    $('.closeactivity').click(function() {
      Cookies.set('currentactivity', '', {
        expires: 7,
        path: '/',
      });
      // console.log('closing modal. window.playerloaded: '+ window.playerloaded+" window.playerID: "+window.playerID);
      if (window.playerloaded == 'yes') {
        // turn off jwplayer if it's running
        jwplayer(window.playerID).stop();
        // console.log("stopping window.playerID: "+window.playerID);
        window.playerloaded == 'no';
      }
      if (
        $(this)
          .parent()
          .parent()
          .attr('aria-hidden') == 'false'
      ) {
        $('.modal').modal('hide');
      }
    });

    $('.js__modal__wrapper__external').on('hidden.bs.modal', function() {
      $(this)
        .find('.closeactivity')
        .first()
        .click();
    });

    $('.nav-tabs').click(() => {
      // console.log('closing nav tab. window.playerloaded: '+ window.playerloaded+" window.playerID: "+window.playerID);
      $('.sp-slide').css('width', '100%');
      $('.sp-mask').css('width', '100%');
      // turn off any jwplayer on the page
      if (window.playerloaded == 'yes') {
        // console.log("stopping window.playerID: "+window.playerID);
        jwplayer(window.playerID).stop();
        window.playerloaded == 'no';
      }
    });

    // show progress for each worked example on the activities main page
    $('.meter > span').each(function() {
      $(this)
        .data('origWidth', $(this).width())
        .width(0)
        .animate(
          {
            width: $(this).data('origWidth'),
          },
          1200,
        );
    });

    // set selected table options
    $('.tablebutton').each(function() {
      if (
        Cookies.get(
          `table${$(this)
            .parent()
            .attr('id')}${$(this).attr('id')}`,
        ) === 'QuestionDone'
      ) {
        $(this).addClass('selected');
      }
    });

    // scrollspy
    // var body = $('body');
    // body.append('<div class="scrollspyList" style="display:none;"><ul class="nav"></ul></div>');
    // var divWithID = $('div[id !=""]');
    // var scrollList = $('.scrollspyList > ul');
    // for (var i = 0; i < divWithID.length; i++) {
    //     var thisDiv = divWithID.eq(i);
    //     scrollList.append('<li><a href="#' + thisDiv.attr('id') + '">' + thisDiv.attr('id') + '</a></li>');
    // }
    // body.css('position', 'relative');
    // body.scrollspy({
    //     target: '.scrollspyList'
    // });
    // $(window).bind('beforeunload', function() {
    //     // do something…
    //     // console.log($('.scrollspyList').find('.active > a').text());
    //     var datastring = 'URL=' + window.location.pathname + '&Activity=' + $('.scrollspyList').find('.active > a').text();
    //     var url = '/HistoryPageController/savePage';
    //     $.ajax({
    //         type: "POST",
    //         url: url,
    //         data: datastring
    //     });
    // });

    // body.on('activate.bs.scrollspy', function() {
    //     // alert($('.active > a').text());
    // });



    // To replace the duplicate Access Keys
      const accessKeysElements = $('[accessKey]');
      const accessKeys = accessKeysElements.map(function(d,i){
          const key = $(this).attr('accesskey');
          return key;
      }).get();
      const uniqueKeys = _.uniqBy(accessKeys)
      uniqueKeys.forEach(function (key,i) {
          const filterEl = $(accessKeysElements).filter(function () {
              return $(this).attr('accesskey') == key
          })
          $(filterEl).each(function (index,el) {
              if(index > 0){
                  $(this).attr('accesskey',`${key}${index}`)
              }
          })
      })
  });

  $.fn.getCursorPosition = function(event) {
    let iCaretPos = 0;
    // IE Support
    if (document.selection) {
      // Set focus on the element
      event.focus();
      // To get cursor position, get empty selection range
      const oSel = document.selection.createRange();
      // Move selection start to 0 position
      oSel.moveStart('character', -event.value.length);
      // The caret position is selection length
      iCaretPos = oSel.text.length;
    } else if (event.selectionStart || event.selectionStart == '0') {
      // Firefox support
      iCaretPos = event.selectionEnd;
    }
    // Return results
    return iCaretPos;
  };

  $.fn.setCursorPosition = function(pos) {
    this.each((index, elem) => {
      if (elem.setSelectionRange) {
        elem.setSelectionRange(pos, pos);
      } else if (elem.createTextRange) {
        const range = elem.createTextRange();
        range.collapse(true);
        range.moveEnd('character', pos);
        range.moveStart('character', pos + 1);
        range.select();
      }
    });
    return this;
  };

  $.fn.actualHeight = function() {
    // find the closest visible parent and get it's hidden children
    const visibleParent = this.closest(':visible').children();
    let thisHeight;

    // set a temporary class on the hidden parent of the element
    visibleParent.addClass('temp-show');

    // get the height
    thisHeight = this.height();

    // remove the temporary class
    visibleParent.removeClass('temp-show');

    return thisHeight;
  };
})(jQuery);

const BranchingActivitySetup = function(modal) {
  // initialise any branching scenario activities
  $('.bsalink').click(function(event) {
    event.preventDefault();
    $(`#${$(this).attr('linkto')}`).show();
    $(`#${$(this).attr('close')}`).hide();
    $('html,body').animate(
      { scrollTop: $(`#${$(this).attr('linkto')}`).offset().top - 100 },
      0,
    );
    if (Cookies.get($(this).attr('close')) === 'QuestionDone') {
    } else {
      window.totalscore =
        parseInt(window.totalscore, 10) + parseInt($(this).attr('score'), 10);
      let score = $(this).attr('score');
      if (score > 0) {
        score = 0;
      } // we don't want any positive scores in our section results

      const activityID = $(this)
        .closest('.isActivity')
        .attr('id');

      Cookies.set($(this).attr('close'), window.totalscore, {
        expires: 7,
        path: '/',
      });
      let finalscore = window.totalscore;
      if (Cookies.get('finalscore')) {
        finalscore =
          parseInt(Cookies.get('finalscore'), 10) +
          parseInt($(this).attr('score'), 10);
      }
      Cookies.set('finalscore', finalscore, {
        expires: 7,
        path: '/',
      });
      Cookies.set($(this).attr('close'), 'QuestionDone', {
        expires: 7,
        path: '/',
      });
    }
  });

  // set the height for each branching scenario
  $('.bs').each(function() {
    const items = $(this).find('.bsScene'); // grab all scenes for this branching scenario
    let heights = []; // create empty array to store height values
    let tallest; // create variable to make note of the tallest slide
    if (items.length) {
      function fixBsHeights() {
        items.each(function() {
          // add heights to array
          $(this).css({
            position: 'absolute', // Optional if #myDiv is already absolute
            visibility: 'hidden',
            display: 'block',
          });
          heights.push($(this).actualHeight());
          // console.log('got '+$(this).actualHeight());
          $(this).css({
            position: 'static', // Again optional if #myDiv is already absolute
            visibility: 'visible',
            // display:    'none'
          });
          if ($(this).hasClass('firstslide')) {
            $(this).css('display', 'inherit');
          } else {
            $(this).css('display', 'none');
          }
        });
        tallest = Math.max.apply(null, heights); // cache largest value
        items.each(function() {
          $(this).css('min-height', `${tallest}px`);
        });
        $(this).css('min-height', `${tallest}px`);
      }
      fixBsHeights();

      $(window).on('resize orientationchange', () => {
        tallest = 0;
        heights = []; // reset vars
        items.each(function() {
          $(this).css('min-height', '0'); // reset min-height
        });
        fixBsHeights(); // run it again
      });
    }
  });

  $('.bsScene').hide();
  $('.firstslide').css('display', 'inherit');
  $('.firstslide').show();

  // look after the scoring -- TODO get this working when muliple branching scenarios are being scored on a sequence type page
  window.currentscore = 0;
  $('.scenarioscore').hide();
  let score = 0;
  const fadespeed = 1500;
  $('.bsalink').click(function(e) {
    // console.log('called bsalink click. Score: '+$(this).attr("score"));
    // console.log('called bsalink click. Current score: '+ $('.scenarioscore').text()+' adding: '+$(this).attr("score"));

    let showscore = '';
    if (parseInt($(this).attr('score')) > 0) {
      showscore = `+${$(this).attr('score')}`;
    } else if (parseInt($(this).attr('score')) < 0) {
      showscore = $(this).attr('score');
    }
    if (showscore != '') {
      $('.scenarioreset').hide();
      $('.scenarioscore').text(showscore);
      $('.scenarioscore')
        .show()
        .fadeOut(fadespeed);
      // console.log('parseInt($(this).attr("score")): '+parseInt($(this).attr("score")));
      score += parseInt($(this).attr('score'));
      $('.finalscenarioscore .scoreNum').html(score);
      $('.finalscenarioscore')
        .hide()
        .fadeIn(fadespeed);
      $('.scenarioreset').fadeIn(fadespeed);
    }
    // get the parameters for SCORM reporting
    const bsID = `#${$(this).attr('bs')}`;
    const sceneID = `#${$(this).attr('close')}`;
    // var minscore = $(this).attr("data-minscore"); // no longer used by the RecordSCORMinteraction function
    // var maxscore = $(this).attr("data-maxscore"); // no longer used by the RecordSCORMinteraction function
    if ($(bsID).attr('data-hideFromSCORM') == 'No') {
      // send an interaction report back to the LMS
      const rawscore = $(this).attr('score');
      const response = $(this).text();
      let activityDetails = $(bsID).attr('data-SCORMdescription');
      if (activityDetails == '') {
        activityDetails = `${$('.page-title').text()} - ${$(bsID).attr(
          'data-activity-name',
        )} - Branching activity`;
      }
      activityDetails += ` Scene Q: ${$(`${sceneID}spark`).text()}`;
      // record the result in SCORM
      // console.log("Branching scenario activity SCORM interaction... activityDetails:"+activityDetails+" rawscore:"+rawscore+" response:"+response);
      RecordSCORMinteraction(activityDetails, rawscore, response);
    } // end check to see if we're reporting this back to the LMS

    // record overall progress in SCORM
    recordActivity(
      $(bsID).attr('data-activity-name'),
      $(bsID).attr('data-activitynum'),
    );

    // record result via xAPI
    // recordTinCanAction(id,activityname,question,response,score)
    //     recordTinCanAction(`${window.location}#${bsID}-${sceneID}`,
    //         `${$('.page-title').text()} - ${$(bsID).attr('data-activity-name')} - Branching activity`,
    //         $(`${sceneID}spark`).text(),
    //         $(this).text(), rawscore);
  });

  $('body').on('hidden', '#branchingscenario_modal', () => {
    // reset to the beginning of the scenario
    window.location.hash = '';
    score = 0;
    $('.finalscenarioscore .scoreNum').html(0);

    $('.bsScene').hide();
    $('.firstslide').show();
    // console.log('enabled draggable');
  });

  $('.scenarioreset').click(() => {
    // reset to the beginning of the scenario
    // console.log('resettng scenario');
    // window.location.hash = '';
    score = 0;
    $('.finalscenarioscore .scoreNum').html(0);

    $('.bsScene').hide();
    $('.firstslide').show();
  });
};

const LoBuilderManagerFn = function() {
  this.registerHandlers = function() {
    if (typeof window.BREADCRUMBS === 'undefined') {
      window.BREADCRUMBS = '';
    }
    let html = '';
    // console.log(BREADCRUMBS);
    if (window.BREADCRUMBS) {
      const data = $.parseJSON(window.BREADCRUMBS);
      $.each(data, (i, page) => {
        if (page.Title !== null && page.Title !== undefined) {
          if (page.last) {
            html = `${html} ${page.Title}`;
          } else {
            html = `${html}<a href="${page.Link}"> ${page.Title} </a> > `;
          }
        }
      });
    }

    $('#jsBreadcrumbs').html(html);
  };
};

const DropDownManagerFn = function() {
  this.registerHandlers = function() {
    $('.featureSelect.newMethod').change(function() {
      // This is how we should do the feedback and is the new method for doing so
      const featureID = $(this).attr('id');
      const correctOption = $(this).data('target');
      const selectedOption = $(this)
        .find(':selected')
        .text();

      if (correctOption == selectedOption) {
        $(`#${featureID}FeedbackCorrect`).show(); // The row and the feedback itself
        $(`#${featureID}FeedbackCorrect .Feedback`).show();

        $(`#${featureID}FeedbackIncorrect`).hide();
        $(`#${featureID}FeedbackIncorrect .Feedback`).hide();
      } else {
        $(`#${featureID}FeedbackCorrect`).hide(); // The row and the feedback itself
        $(`#${featureID}FeedbackCorrect .Feedback`).hide();

        $(`#${featureID}FeedbackIncorrect`).show();
        $(`#${featureID}FeedbackIncorrect  .Feedback`).show();
      }

      if (Cookies.get(featureID) === 'QuestionDone') {
      }else {
        Cookies.set(featureID, 'QuestionDone', {
          expires: 7,
          path: '/',
        });
        let totalScore = parseInt($(this).attr('data-score'));
        let finalscore = window.totalscore;
        if (Cookies.get('finalscore')) {
          
          finalscore =
              parseInt(Cookies.get('finalscore'), 10) +
              totalScore;
        }else {
          finalscore =  parseInt(totalScore)
        }
        Cookies.set('finalscore', finalscore, {
          expires: 7,
          path: '/',
        })
      }
    });
  };
};

const ClozeTestManagerFn = function() {
  this.registerHandlers = function() {
    $('.clozeTest').each(function() {
      // do this for each cloze test on the page
      // console.log( index + " cloze test: " + $( this ).text() );
      const options = $(this)
        .attr('data-options')
        .split(',')
        .sort();
      // console.log(options);
      const content = $(this).html();
      let target = '';
      let answer = '';
      let score = 0;
      let maxscore = 0;
      const id = `#${$(this).attr('id')}`;

      $('.cloze', id).each(function(index2, value) {
        let selection = `<select role="listbox" accesskey="${index2}" data-choices-id="${index2}"><option value="Choose...">Choose...</option>`;
        // build a select dropdown for each of the blanks
        for (let i = 0; i < options.length; ++i) {
          selection += `<option role="option" accesskey="${i}" data-option-id="${i}" value="${options[
            i
          ].trim()}">${options[i].trim()}</option>`;
        }
        selection += '</select>';
        // console.log(selection);

        // replace each of the target words with the select dropdown
        $(this).attr('data-answer', $(this).text());
        $(this).html(selection);
      });

      // set up the feedback button for this test
      $('.clozeQuestionButton', id).click(function(e) {
        // console.log ("data-clozeQuestionButton clicked");
        score = 0;
        $('.cloze', id).each(function(index, value) {
          let response;
          maxscore += 1;
          target = $(this).attr('data-answer');
          answer = $('select option:selected', this).text();
          if (target == answer) {
            response = `<span class='text-success'><strong>${target}</strong></span>`;
            score += 1;
          } else {
            response = `<span class='text-error'><strong>${target}</strong> (you selected ${answer})</span>`;
          }
          $(this).html(response);
        });
        $(this).attr('disabled', 'disabled');

        // forget about feedback for now, just hide the button
        // feedback = '<span class="cqFeedback">You scored '+parseInt(score/maxscore*100)+'%</span>';
        // $(this).html(feedback);

        // get the parameters for SCORM reporting
        const activitynum = $(this).attr('data-activitynum');
        const minscore = $(id).attr('data-minscore');
        maxscore = $(id).attr('data-maxscore');
        let response;
        if ($(this).attr('data-hideFromSCORM') == 'No') {
          // send an interaction report back to the LMS
          let activityDetails = $(this).attr('data-SCORMdescription');
          if (activityDetails == '') {
            activityDetails = `${$('.page-title').text()} - ${$(this).attr(
              'data-activity-name',
            )} - Cloze test Question`;
          }
          // record the result in SCORM
          response = `${$(
            `#clozeTestQuestion${activitynum}`,
          ).text()}  ${parseInt(score / maxscore * 100)} percent correct`;
          // console.log("Cloze test SCORM interaction... activityDetails:"+activityDetails+" rawscore:"+score+" response:"+response);
          RecordSCORMinteraction(activityDetails, score, response);
        } // end check to see if we're reporting this back to the LMS

        // record overall progress in SCORM
        recordActivity(
          $(this).attr('data-activity-name'),
          $(this).attr('data-activitynum'),
        );

        // record result via xAPI
        // recordTinCanAction(id,activityname,question,response)
        //     recordTinCanAction(`${window.location}_f${activitynum}`,
        //         activityDetails,
        //         $('.ClozeTestQuestion', id).text(),
        //         response, score);
        //
        $(this).hide();
      });
    });
  };
};

const MatchingPairManagerFn = function() {
  this.registerHandlers = function() {};
};

// const tabWranglerFn = function (x) {
//     if (x != undefined && x.indexOf('#') > 0) {
//         $(`#Sections a[href="${x}"]`).tab('show');
//             // $('.modal').modal('hide');
//     }
// };

const TableManagerFn = function() {
  this.registerHandlers = function() {
    // set up the answer buttons.
    $('body').on('click', '.tablebutton', function(e) {
      loDebug('Table button clicked');
      // e.stopPropagation();    //Had to remove this to stop other problems. Not sure why it is here
      e.preventDefault();

      const ID = $(this)
        .parent()
        .attr('id');
      // get the parameters for SCORM reporting
      const activitynum = $(this).attr('data-activitynum');
      // var minscore = $(this).attr("data-minscore"); // no longer used by the RecordSCORMinteraction function
      // var maxscore = $(this).attr("data-maxscore"); // no longer used by the RecordSCORMinteraction function
      $(this)
        .closest(`#${ID}.btn-group`)
        .children()
        .removeClass('selected-choice');
      $(this).addClass('selected-choice'); // Assign a colour on click
      let response;
      if ($(this).attr('data-hideFromSCORM') == 'No') {
        // send an interaction report back to the LMS
        const rawscore = $(this).attr('score');
        response = `${$(this).text()}  ${$(this).attr('result')}`;
        let activityDetails = $(this).attr('data-SCORMdescription');
        if (activityDetails == '') {
          activityDetails = `${$('.page-title').text()} - ${$(this).attr(
            'data-activity-name',
          )} - Table Q: ${$(`#Question${activitynum}`).text()}`;
        }
        activityDetails += ` Table Q: ${$(`#Question${activitynum}`).text()}`;
        // record the result in SCORM
        // console.log("Table activity SCORM interaction... activityDetails:"+activityDetails+" rawscore:"+rawscore+" response:"+response);
        RecordSCORMinteraction(activityDetails, rawscore, response);
      } // end check to see if we're reporting this back to the LMS

      // record overall progress in SCORM
      recordActivity(
        $(this).attr('data-activity-name'),
        $(this).attr('data-activitynum'),
      );

      // record result via xAPI
      // recordTinCanAction(id,activityname,question,response)
      // recordTinCanAction(`${window.location}_table${activitynum}`,
      //     `${$('.page-title').text()} - ${$(this).attr('data-activity-name')} - Table Activity`,
      //     $(`#Question${activitynum}`).text(),
      //     response, rawscore);
      let $target;
      let $source;
      if ($(this).attr('showbelowrow') == '1') {
        // show the feedback in the row below the buttons
        loDebug('Table feedback showing below');

        $target = $(this).attr('data-target');
        $source = $(this).attr('target');
        loDebug('Table feedback showing in', $target, 'data', $source);

        // console.log('source: '+$source+' target: '+$target);
        // $("#" + $target + "target").removeClass('alert-success alert-error');
        // $("#" + $target + "target").addClass($(this).attr('result'));
        // $("#" + $target + "target").addClass($(this).attr('score'));

        $(this)
          .closest('tbody')
          .find(`#${$target}target`)
          .html('');
        const sourceCloned = $(this)
          .closest('tbody')
          .find(`#${$source}`)
          .clone();
        sourceCloned.attr('id', `${sourceCloned.attr('id')}cloned`);
        sourceCloned.show();
        $(this)
          .closest('tbody')
          .find(`#${$target}target`)
          .append(sourceCloned);

        $(this)
          .closest('tbody')
          .find(`#${$target}row`)
          .show();

        // $("#" + $target + "target").addClass($("#" + $source).html());

        // $("#" + $target + "target").html($("#" + $source).html());
        // $("#"+$source).clone().appendTo("#"+$target+"target");
      } else {
        // show feedback in the same cell as the buttons
        $(this)
          .closest('td')
          .removeClass('success error');
        $(this)
          .closest('td')
          .addClass($(this).attr('result'));
        $(this)
          .closest('td')
          .addClass($(this).attr('score'));
      }
      // $(this).siblings().hide();
      // $(this).addClass('disabled');
      const scope = $(this).closest('td');
      $('.Feedback', scope).hide();
      let fb;
      $(this)
        .closest('tbody')
        .find(`#${ID}response`)
        .removeClass('text-error text-success');
      if ($(this).attr('prevent-feedback') != '1') {
        if ($(this).attr('result') == 'success') {
          $(this)
            .closest('tbody')
            .find(`#${ID}response`)
            .addClass('text-success');
          fb = `<strong  class='gh__activity_table_autofeedback'  >'${$(
            this,
          ).text()}' is Correct</strong>`;
        } else if ($(this).attr('result') == 'error') {
          $(this)
            .closest('tbody')
            .find(`#${ID}response`)
            .addClass('text-error');
          fb = `<strong  class='gh__activity_table_autofeedback' >'${$(
            this,
          ).text()}' is Incorrect</strong>`;

          // RPL record incorrect responses for later reporting on prior learning pages
          // var heading = $(this).closest('.isActivity').data('heading');

          // if ($.inArray(heading, window.checkIncorrectActivities) == -1) {
          //  window.checkIncorrectActivities.push(heading);
          // }
        } else {
          fb = '';
        }
        $(this)
          .closest('tbody')
          .find(`#${ID}response`)
          .html(fb);
        $(this)
          .closest('tbody')
          .find(`#${ID}response`)
          .show();
        if ($(this).attr('showbelowrow') == '1') {
          // move any existing feedback back to its original position in the DOM
          // console.log($("#"+$target+"target"));
          // $("#"+$target+"target").children().first().appendTo($("#"+$target+"target").attr('data-from'));
          // $("#"+$target).detach().appendTo("#"+$target+"target");
          // console.log('showing '+"#"+$target+"row");
          $(this)
            .closest('tbody')
            .find(`#${ID}response`)
            .remove(); // We don't need the first response span so rempve it, causes shitfting
          $(this)
            .closest('tbody')
            .find(`#${$target}row`)
            .removeClass('hidden');
          $(this)
            .closest('tbody')
            .find(`#${$target}row`)
            .show(300);
        } else {
          // a regular 'show feedback directly below the buttons' table
          $(this)
            .closest('tbody')
            .find(`#${$(this).attr('target')}`)
            .show(300);
        }
        let done = false;
        if (
          Cookies.get(
            `table${$(this)
              .parent()
              .attr('id')}${$(this).attr('id')}`,
          ) === 'QuestionDone'
        ) {
          done = true;
        } else if ($(this).siblings().length > 0) {
          $(this)
            .siblings()
            .each(function() {
              if (
                Cookies.get(
                  `table${$(this)
                    .parent()
                    .attr('id')}${$(this).attr('id')}`,
                ) === 'QuestionDone'
              ) {
                done = true;
              } else {
              }
            });
        }

        if (done == true) {
        } else {
          window.totalscore =
            parseInt(window.totalscore, 10) +
            parseInt($(this).attr('score'), 10);
          let score = $(this).attr('score');
          if (score > 0) {
            score = 0;
          }
          // we don't want any positive scores in our section results

          const activityID = $(this)
            .closest('.isActivity')
            .attr('id');

          Cookies.set($(this).attr('data-activitynum'), window.totalscore, {
            expires: 7,
            path: '/',
          });
          let finalscore = window.totalscore;
          if (Cookies.get('finalscore')) {
            finalscore =
              parseInt(Cookies.get('finalscore'), 10) +
              parseInt($(this).attr('score'), 10);
          }
          Cookies.set('finalscore', finalscore, {
            expires: 7,
            path: '/',
          });
          Cookies.set(
            `table${$(this)
              .parent()
              .attr('id')}${$(this).attr('id')}`,
            'QuestionDone',
            {
              expires: 7,
              path: '/',
            },
          );
          $(this).addClass('selected');
        }
      }
    });

    // reset the table when the modal box is closed
    $('body').on('hidden', '.modal', () => {
      $('td').removeClass('success error');
      $('.Feedback').hide();
      $('.mcFeedback').hide();
      $('.btn').removeClass('disabled');
      $('.tablebutton').show();
    });
  };
};
const DragandDropManagerFn = function() {
  this.registerHandlers = function() {
    $('.hideDnDfeedback').hide();


    if($('.DnDsource li').length){
        $('.DnDsource li').draggable({
            connectToSortable: '#target',
            start(e, ui) {
                $(ui.helper).addClass('ui-draggable-helper');
            },
            revert: 'invalid',
        });
    }

    if( $('.DnDtarget ol').length){
        $('.DnDtarget ol')
            .droppable({
                activeClass: 'ui-state-default',
                hoverClass: 'ui-state-hover',
                accept: ':not(.ui-sortable-helper)',
                tolerance: 'touch',
                drop(event, ui) {
                    $(this)
                        .find('.placeholder')
                        .hide();
                    $(ui.helper).hide();
                    $(ui.helper).draggable('option', 'revert', true);
                    $('<li></li>')
                        .html(ui.draggable.html())
                        .appendTo(this);
                    if (Cookies.get('finalscore')) {
                        Cookies.set(
                            'finalscore',
                            parseInt(Cookies.get('finalscore'), 10) +
                            parseInt(
                                $(this)
                                    .children()
                                    .children('.DragChoice')
                                    .attr('data-score'),
                                10,
                            ),
                            {
                                expires: 7,
                                path: '/',
                            },
                        );
                    } else {
                        Cookies.set(
                            'finalscore',
                            $(this)
                                .children()
                                .children('.DragChoice')
                                .attr('data-score'),
                            {
                                expires: 7,
                                path: '/',
                            },
                        );
                    }
                },
            })
            .sortable();
    }



    const showDnDfeedback = function(dndObj) {
      $('.DnDsource .dndT').addClass('alert-error');
      $('.DnDsource .dndF').addClass('wasFeedback');
      $('.DnDsource .dndF').removeClass('Feedback');
      $('.DnDtarget .dndF').addClass('alert-error');
      $('.DnDtarget .dndT').addClass('alert-success');
      $('.DragAndDrop .Feedback').each(function() {
        if (
          $(this)
            .text()
            .trim() != ''
        ) {
          $(this).show();
        }
      });

      $('.showDnDfeedback').hide();
      $('.hideDnDfeedback').show();
      // get the parameters for SCORM reporting
      // var minscore = $(id).attr("data-minscore"); // no longer used by the RecordSCORMinteraction function
      // var maxscore = $(id).attr("data-maxscore"); // no longer used by the RecordSCORMinteraction function
      if (dndObj.attr('data-hideFromSCORM') == 'No') {
        // send an interaction report back to the LMS
        let activityDetails = dndObj.attr('data-SCORMdescription');
        if (activityDetails == '') {
          activityDetails = `${$('.page-title').text()} - ${dndObj.attr(
            'data-activity-name',
          )} - Q ${dndObj.attr('data-activity-question')} - Possible total ${$(
            '.DnDsource .dndT',
          ).length +
            $('.DnDtarget .dndF').length +
            $('.DnDtarget .dndT').length} points`;
        }
        // record the result in SCORM
        const response = `${
          $('.DnDsource .dndT').length
        } not dropped correctly, ${
          $('.DnDtarget .dndF').length
        } dropped incorrectly, ${
          $('.DnDtarget .dndT').length
        } dropped correctly`;
        const rawscore = $('.DnDtarget .dndT').length;
        // console.log("Drage and drop test SCORM interaction... activityDetails:"+activityDetails+" rawscore:"+rawscore+" response:"+response);
        RecordSCORMinteraction(activityDetails, rawscore, response);
      } // end check to see if we're reporting this back to the LMS

      // record overall progress in SCORM
      recordActivity(
        dndObj.attr('data-activity-name'),
        dndObj.attr('data-activitynum'),
      );

      // record result via xAPI
      // recordTinCanAction(id,activityname,question,response)
      // recordTinCanAction(`${window.location}_dndrop`, // TODO should have an activity number here too
      //     activityDetails,
      //     '',
      //     response, rawscore);
    };

    $('.showDnDfeedback').click(function() {
      showDnDfeedback($(this));
    });

    // I've got no idea what this is doing here. I'm guessing a keyboard shortcut for showing feedback by pressing the 'f' key. Lambo doesn't recognize it either.
    // It's causing all sorts of havoc with other activities though (errors on pages with no dnd activities, double inputs on short answer questions etc.)
    // so I've commented it out for now. PS 11th Nov 2014
    // $(document).bind('keypress', 'f', function(evt) {
    //     showDnDfeedback();
    //     return false;
    // });

    const hideDnDfeedback = function() {
      $('.wasFeedback').addClass('Feedback');
      $('.DnDsource .Feedback').removeClass(
        'alert-success alert-error wasFeedback',
      );
      $('.DnDtarget .Feedback').removeClass(
        'alert-success alert-error wasFeedback',
      );
      $('.DragAndDrop .Feedback').hide();
      $('.hideDnDfeedback').hide();
      $('.showDnDfeedback').show();
    };

    $('.hideDnDfeedback').click(function() {
      hideDnDfeedback($(this));
    });

    /* Comment out because it was causing tmt-topics search not work
         $(document).bind('keypress', 'r', function(evt) {
              hideDnDfeedback();
             return false;
         }); */

    $('.DnDreset').click(() => {
      $('.ui-widget-content').show();
      $('.DnDanswers').html(
        '<li class="placeholder">Drop your paragraphs here.<br><br><br></li>',
      );
      $('.wasFeedback').addClass('Feedback');
      $('.DnDsource .Feedback').removeClass(
        'alert-success alert-error wasFeedback',
      );
      $('.DnDtarget .Feedback').removeClass(
        'alert-success alert-error wasFeedback',
      );
      $('.Feedback').hide();
      $('.showDnDfeedback').show();
      $('.hideDnDfeedback').hide();
    });

    String.prototype.splice = function(idx, rem, s) {
      return this.slice(0, idx) + s + this.slice(idx + Math.abs(rem));
    };
  };
};

const StateManagerFn = function() {
  $('#States .Feedback').hide();
  $('#AUStates .Feedback').hide();
  this.registerHandlers = function() {
    $('body').on('click', '#States .Choice', function(e) {
      // console.log(this);
      // console.log('choice clicked');
      // console.log('the next one for this is '  + $(this).contents('.current').text());
      const current = $(this)
        .contents('.current')
        .text(); // hide the old one
      const next = $(this)
        .contents('.next')
        .text(); // show the next one.
      // console.log('next #' + next);
      const hide = $(this)
        .contents('.hide')
        .text(); // show the next one.
      // console.log($(this).contents('.StateFeedback'));
      const feedback = $(this)
        .contents('.StateFeedback')
        .text()
        .trim();
      // console.log('feedback = '+feedback);
      if (feedback == '') {
        // no feedback to show, just move on to next state
        if (hide != 0) {
          $(`#${current}`).hide();
        }
        $(`#${next}`).show();
        $.scrollTo(`#${next}`, 1000, {
          offset: -60,
        });
      } else {
        // show feedback and 'next' button
        $(this)
          .contents('.StateFeedback')
          .show();
        $('.StateFeedback').unbind('click');
        $('body').on('click', '.StateFeedback', e => {
          // console.log(hide);
          if (hide != 0) {
            $(`#${current}`).hide();
          }
          $(`#${next}`).show();
          $.scrollTo(`#${next}`, 1000, {
            offset: -60,
          });
        });
      } // got feedback to show
      // $('#State_2').show()
      return true;
    });

    $('body').on('click', '#AUStates .Choice', function(e) {
      // console.log(this);
      // console.log('choice clicked');
      // console.log('the next one for this is '  + $(this).contents('.current').text());
      const current = $(this)
        .contents('.current')
        .text(); // hide the old one
      const next = $(this)
        .contents('.next')
        .text(); // show the next one.
      // console.log('next #' + next);
      const hide = $(this)
        .contents('.hide')
        .text(); // show the next one.
      // console.log($(this).contents('.StateFeedback'));
      const feedback = $(this)
        .contents('.StateFeedback')
        .text()
        .trim();
      // console.log('feedback = '+feedback);
      if (feedback == '') {
        // no feedback to show, just move on to next state
        if (hide != 0) {
          $(`#${current}`).hide();
        }
        $(`#${next}`).show();
        $.scrollTo(`#${next}`, 1000, {
          offset: -60,
        });
      } else {
        // show feedback and 'next' button
        $(this)
          .contents('.StateFeedback')
          .show();
        $('.StateFeedback').unbind('click');
        $('body').on('click', '.StateFeedback', e => {
          // console.log(hide);
          if (hide != 0) {
            $(`#${current}`).hide();
          }
          $(`#${next}`).show();
          $.scrollTo(`#${next}`, 1000, {
            offset: -60,
          });
        });
      } // got feedback to show
      // $('#State_2').show()
      return true;
    });
  };
};

const FeedbackManagerFn = function() {
  $('.Feedback').hide();
  $('.mcFeedback').hide();
  this.registerHandlers = function() {
    $('.mcFeedback').hide();
    // Multichoice checkbox feedback
    $('body').on('click', '.showMCfeedback', function(e) {
      $('body').css('cursor', 'wait');
      const container = $(
        `#MultiChoiceQuestion${$(this).attr('data-activitynum')}`,
      );
      $('.mcFeedback', container).hide();
      const marks = [];
      let totalScore = 0;
      $('input', container).each(function(index, value) {
        if (this.checked == $(this).data('t')) {
          $(`#${$(this).attr('target')}`).removeClass(
            'alert-error gh__block__mcq--checkboxes__container__options__option__feedback--incorrect',
          );
          $(`#${$(this).attr('target')}`).addClass(
            'alert-success gh__block__mcq--checkboxes__container__options__option__feedback--correct',
          );
          marks[index] = true;
          // see ifthis is correct or not
          //     if ($(this).attr('t') == "0") { // incorrect
          //         $('#' + $(this).attr('target')).removeClass('alert-success');
          //         $('#' + $(this).attr('target')).addClass('alert-error');
          //         mark[index] = false;
          //
          //     } else {
          //         $('#' + $(this).attr('target')).removeClass('alert-error');
          //         $('#' + $(this).attr('target')).addClass('alert-success');
          //         mark[index] = true;
          //     }
          //     $('#' + $(this).attr('target')).show();
          // } else { // not checked, see if it should have been
          //     if ($(this).attr('t') == "1") { // incorrect response (should have been checked)
          //         $('#' + $(this).attr('target')).removeClass('alert-success');
          //         $('#' + $(this).attr('target')).addClass('alert-error');
          //         mark[index] = false;
          //     } else {
          //         $('#' + $(this).attr('target')).removeClass('alert-error');
          //         $('#' + $(this).attr('target')).addClass('alert-success');
          //         mark[index] = true;
          //     }
        } else {
          $(`#${$(this).attr('target')}`).removeClass(
            'alert-success gh__block__mcq--checkboxes__container__options__option__feedback--correct',
          );
          $(`#${$(this).attr('target')}`).addClass(
            'alert-error gh__block__mcq--checkboxes__container__options__option__feedback--incorrect',
          );
          marks[index] = false;
        }
        if($(`#${$(this).attr('target')}`).attr('data-isneutralfeedback')){
          $(`#${$(this).attr('target')}`).removeClass(
              'alert-error gh__block__mcq--checkboxes__container__options__option__feedback--incorrect',
          );
          $(`#${$(this).attr('target')}`).removeClass(
              'alert-success gh__block__mcq--checkboxes__container__options__option__feedback--correct',
          );
          $(`#${$(this).attr('target')}`).addClass(
              'alert-info gh__block__mcq-buttons--vertical__options__option__feedback--neutral',
          );
          
        }

        if(this.checked){
          const score = $(this).attr('score');
          const datascore = $(this).attr('data-score');
          if(score){
            totalScore = totalScore+ parseInt(score)
          }
          if(datascore){
            totalScore = totalScore+ parseInt(datascore)
          }
          $(`#${$(this).attr('target')}`).show();
        }
      });
      if (container.hasClass('mcOneFeedback')) {
        if (marks.indexOf(false) != -1) {
          // Mark it as wrong if one answer is incorrect
          $('.Feedback', container).removeClass(
            'alert-success gh__block__mcq--checkboxes__container__options__option__feedback--correct',
          );
          $('.Feedback', container).addClass(
            'alert-error gh__block__mcq--checkboxes__container__options__option__feedback--incorrect',
          );
        } else {
          $('.Feedback', container).removeClass(
            'alert-error gh__block__mcq--checkboxes__container__options__option__feedback--incorrect',
          );
          $('.Feedback', container).addClass(
            'alert-success gh__block__mcq--checkboxes__container__options__option__feedback--correct',
          );
        }
      }
      $('body').css('cursor', 'default');
      $(container).addClass('gh__mcq--feedback-showing');
      
      const mcqid  = `${$(this).attr('data-activitynum')}mcq`
      if (Cookies.get(mcqid) === 'QuestionDone') {
        
      }else {
        Cookies.set(mcqid, 'QuestionDone', {
          expires: 7,
          path: '/',
        });
        if(totalScore){
          let finalscore = window.totalscore;
          if (Cookies.get('finalscore')) {
            finalscore =
                parseInt(Cookies.get('finalscore'), 10) +
                totalScore;
          }
          Cookies.set('finalscore', finalscore, {
            expires: 7,
            path: '/',
          });
        }
      }
      
      e.stopPropagation();
      e.preventDefault();
    });

    $('textarea').change(function() {
      $(this).text($(this).val());
    }); // update the dom with any text area content for short answer questions
    // set up the short answer buttons.

    $('body').on('keyup', '.ShortAnswerQuestion input', function(e) {
      if (e.keyCode == 13) {
        e.preventDefault();
        const parentDiv = $(this).closest('.ShortAnswerQuestion');
        if (parentDiv.parent().find('.next-sequence-activity').length > 0) {
          parentDiv
            .parent()
            .find('.next-sequence-activity')
            .click();
        } else {
          const feedbackButton = parentDiv.children('button.feedback-button');
          feedbackButton.removeClass('try-again');
          feedbackButton.click();
        }
      }
    });
    $('body').on('click', '.ShortAnswerFeedback', function(e) {
      let subjective = false;
      let correct = false;

      const feedbackButton = $(this);
      const parentDiv = $(this).closest('.ShortAnswerQuestion');

      const correctDiv = $(`#${$(this).attr('id')}Correct`);
      const inCorrectDiv = $(`#${$(this).attr('id')}InCorrect`);

      if ($(this).hasClass('try-again')) {
        correctDiv.hide();
        inCorrectDiv.hide();
        feedbackButton.text(feedbackButton.data('text'));
        feedbackButton.removeClass('try-again');
      } else if (
        $(this)
          .attr('class')
          .match('ShortAnswerSubjectiveFeedback')
      ) {
        subjective = true;

        correct = SASubjectiveFeedbackHandler(feedbackButton, parentDiv);
      } else {
        // $(this).prev().show().prev().hide();
        $(this)
          .prev()
          .show();
        $(this).hide();
      }

      if ($('.noResponseForPeer').length > 0) {
        $('.noResponseForPeer').show();
      }

      // show peer assessment instruction
      if ($('.PeerAssessmentInstructions').length > 0) {
        $('.PeerAssessmentInstructions').show();
      }
      // show peer assessment form
      if ($('.PeerAnswer').length > 0) {
        $('.PeerAnswer').show();
      }

      // get the parameters for SCORM reporting

      const activitynum = $(this).attr('data-activitynum');
      // var minscore = $(this).attr("data-minscore"); // no longer used by the RecordSCORMinteraction function
      // var maxscore = $(this).attr("data-maxscore"); // no longer used by the RecordSCORMinteraction function
      if ($(this).attr('data-hideFromSCORM') == 'No') {
        // send an interaction report back to the LMS
        if (subjective) var rawscore = correct ? 1 : 0;
        else var rawscore = 0;
        const response = $(`#Answer${activitynum}`).html();
        let activityDetails = $(this).attr('data-SCORMdescription');
        if (activityDetails == '') {
          activityDetails = `${$('.page-title').text()} - ${$(this).attr(
            'data-activity-name',
          )} - Short answer Q: ${$(`#Question${activitynum}`).text()}`;
        }
        // record the result in SCORM
        // console.log("Short answer SCORM interaction... activityDetails:"+activityDetails+" rawscore:"+rawscore+" response:"+response);
        RecordSCORMinteraction(activityDetails, rawscore, response);
      } // end check to see if we're reporting this back to the LMS

      // record overall progress in SCORM
      recordActivity(
        $(this).attr('data-activity-name'),
        $(this).attr('data-activitynum'),
      );

      // record result via xAPI
      // recordTinCanAction(id, activityname, question, answer, rawscore)
      // recordTinCanAction(`${window.location}_sa${activitynum}`,
      //     `${$('.page-title').text()} - ${$(this).attr('data-activity-name')} - Short answer Question`,
      //     $(`#Question${activitynum}`).text(),
      //     response, rawscore);

      /*
             $("#ShortAnswerQuestion .Feedback").toggle();
             $("#ShortAnswerQuestion .Response").toggle();
             $("#ShortAnswerQuestion .ShortAnswerFeedback").hide();
             */
      // send response to moderator
      if ($(this).hasClass('sendResponseToModerator')) {
        const tempEmail = $(this).attr('data-responsemoderatoremail');
        const tempResponse = $(`#Answer${activitynum}`).val();
        const datastring = `ActivityID=${activitynum}&Response=${tempResponse}&ModeratorEmail=${tempEmail}`;
        const url = '/gh-api/peerfeedback/shortAnswerResponseModerate'; // TODO: this is broken
        $.ajax({
          type: 'POST',
          url,
          data: datastring,
        });
        const databaseurl = '/SaveAsController/SaveToDatabase';
        const verb = 'Add Response ';
        const databaseString = `activityid=${activitynum}&Object=${tempResponse}&Verb=${verb}`;
        $.ajax({
          type: 'POST',
          url: databaseurl,
          data: databaseString,
        });
      }

        const response = $(`#Answer${activitynum}`).val();
        window.store.dispatch(window.actions.shortQuestionAnswerFeedback(activitynum, response));

    });

    $('body').on('click', '.Choice', function(e) {
      // console.log(this);
      // console.log('choice clicked');
      if (!$(this).parents('.mcOneFeedback').length) {
        $(this)
          .closest('.MultipleChoiceQuestion')
          .find('.Feedback')
          .hide();
        $(this)
          .children('.Feedback')
          .show();
      }
      // $("#ShortAnswerQuestion .Response").toggle();
      // /$("#ShortAnswerQuestion .ShortAnswerFeedback").hide();
    });

    // overall feedback .
    $('body').on('click', '.overallFeedbackButton', function() {
      showFeedbackRange(
        $(this)
          .closest('.FeedbackRangeContainer')
          .parent(),
      );
    });

    // overall score changes
    $('body').mousedown(() => {
      if (Cookies.get('finalscore') && Cookies.get('finalscore') != 0) {
        if ($('.EmptyScore').css('display') != 'none') {
          if ($('.overallFeedbackButton').length > 0) {
            $('.overallFeedbackButton').show();
          }

          $('.EmptyScore').hide();
        }
      }
    });

    // show overall feedback when click on class

      const getTriggerClass = Cookies.getJSON('triggerclass');

      if (getTriggerClass && Array.isArray(getTriggerClass) && Cookies.getJSON('triggerclass').length > 1) {
          $.each(Cookies.getJSON('triggerclass'), function() {
              $('body').on('click', `.${this}`, function() {
                  showFeedbackRange(
                      $(this)
                          .parent()
                          .parent(),
                  );
              });
          });
      } else if (getTriggerClass && Array.isArray(getTriggerClass) && getTriggerClass[0] != '') {
          $('body').on(
              'click',
              `.${Cookies.getJSON('triggerclass')[0]}`,
              function() {
                  showFeedbackRange(
                      $(this)
                          .parent()
                          .parent(),
                  );
              },
          );
      }
  };
};

export function showFeedbackRange(context,showFeddbackPercentRange) {


  // if (DEBUGGING) console.log('Showing range based feedback');
  if (context.find('.FeedbackRange').length > 0) {
    context.find('.FeedbackRange').hide();
    context.find('.FeedbackRange').each(function() {
      const min = $(this).attr('min-score');
      const max = $(this).attr('max-score');
      // if (DEBUGGING) console.log('Final score is:', Cookies.get('finalscore'));
        let finalscore = 0;
      if (Cookies.get('finalscore')) {
          finalscore = Cookies.get('finalscore');
        if (
          parseInt(finalscore, 10) <= parseInt(max, 10) &&
          parseInt(finalscore, 10) >= parseInt(min, 10)
        ) {
          const changeContent = $(this)
            .html()
            .replace('ScoreSource', finalscore);
          $(this).html(changeContent);
          let totalScore = 0;
          let percent = 0;
          if(showFeddbackPercentRange && showFeddbackPercentRange=='show_percent_feedback_range'){
            const allScoreElements = $('*[score], *[data-score]');
            allScoreElements.each(function () {
              const score = $(this).attr('score');
              const datascore = $(this).attr('data-score');
              if(score){
                totalScore = totalScore+ parseInt(score)
              }
              if(datascore){
                totalScore = totalScore+ parseInt(datascore)
              }
            })
            percent = 100 * (finalscore/totalScore);
          }
              var foundElement = '';
              $('*[data-feedback-percent]').hide();
              $('*[data-feedback-percent]').each(function () {
                const feedbackData = $(this).attr('data-feedback-percent');
                if(feedbackData >= percent){
                  foundElement = feedbackData;
                }
                if(foundElement){
                  return false;
                }
              })
              $(`*[data-feedback-percent="${foundElement}"]`).show()
          $(this).show();
          $('.overallFeedbackButton').hide();
        }

      }
        window.store.dispatch(window.actions.setShowFeedbackRange(finalscore))
    });
  }
}
window.showFeedbackRange = showFeedbackRange;
// Share function with action manager and the image map manager that opens the modal boxes

export function hidePopovers() {
  debug('Hide popovers triggered');
  $('.popover').each((index, val) => {
    $(val).popover('hide');
  });
}
function openModal(actionClass, { context } = {}) {
  debug('openModal triggered');
  const newActionClass = actionClass.split(/ +/);
  $.each(newActionClass, (index, value) => {
    if (jQuery.inArray(`.${value}`, window.ACTION_CLASSES) !== -1) {
      actionClass = value;
      return false;
    }
  });

  const modalToShow = $(`#${actionClass}_modal`);
  // if ($('.trackcircle').length > 0) {

  // this DPET and RPET specificaiton code
  const key = `.${actionClass}`;
  let currentModal = actionClass + '_modal';

  //change the css on the actual page
  $(`#${actionClass}`).removeClass('tracknotdone');
  $(`#${actionClass}`).addClass('trackdone');

  //do that change for side toolbar
  $(`#progressbar #activity${actionClass}_modal`).removeClass('tracknotdone');
  $(`#progressbar #activity${actionClass}_modal`).addClass('trackdone');

  let modalActivitiesDone = Array();

  if (Cookies.get('modalActivitiesDone') != null) {
    modalActivitiesDone = Cookies.getJSON('modalActivitiesDone');
  }

  //const found = $.inArray($(this).attr('id'), modalActivitiesDone);
  ///alert(found);
  //if (found < 0) {

  modalActivitiesDone.push(currentModal);

  console.log('modalActivitiesDone: ' + modalActivitiesDone);

  Cookies.set('modalActivitiesDone', modalActivitiesDone, {
    expires: 7,
    path: '/',
  });
  //}

  let visited = {};
  if (Cookies.get('visited')) {
    visited = Cookies.getJSON('visited');
    visited[key] = '1';
    const input = JSON.stringify(visited);
    Cookies.get('visited', input, {
      expires: 7,
      path: '/',
    });
  } else {
    visited[key] = '1';
    // var input = JSON.stringify(visited);
    Cookies.set('visited', visited, {
      expires: 7,
      path: '/',
    });
  }
  // }
  // console.log('#' + actionClass + '_modal');
  // close any open modals
  // $('.modal').modal('hide'); // This might be needed again but currently causes problems

  const isPop = modalToShow.data('popover');
  // var isPop = 1;

  if (isPop == 1) {
    debug('Is being shown as a popover');
    // alert('show in pop over');

    let hotspotTrigger;
    if (context) {
      hotspotTrigger = $(context)
        .closest(`*[data-trigger="${actionClass}"]`)
        .not('.mcOption');
      if (hotspotTrigger.length == 0) {
        hotspotTrigger = $(context).closest(`.${actionClass} img`);
      }
      if (hotspotTrigger.length == 0) {
        hotspotTrigger = $(context).closest(`.${actionClass}`);
      }
    }
    if (hotspotTrigger.length == 0) {
      hotspotTrigger = $(`*[data-trigger="${actionClass}"]`).not('.mcOption');
    }

    if (hotspotTrigger.length == 0) {
      hotspotTrigger = $(`.${actionClass} img`);
    }
    if (hotspotTrigger.length == 0) {
      hotspotTrigger = $(`.${actionClass}`);
    }

    // var hotspotTrigger =  $('.' + actionClass);
    const sourceHotSpot = hotspotTrigger.first();

    if (
      sourceHotSpot.parent().find('.popover').length &&
      !$(`#${actionClass}_modal`).data('hover')
    ) {
      hidePopovers();
    } else if (!sourceHotSpot.parent().find('.popover').length) {
      const popoverContent = $(`#${actionClass}_modal .modal-body`).html();
      hidePopovers();

      if (!$(`#${actionClass}_modal`).data('hover')) {
        $('body').on('click', `.removepopover${actionClass}`, e => {
          // did not click a popover toggle or popover
          if (
            $(e.target).data('toggle') !== 'popover' &&
            $(e.target).parents('.popover.in').length === 0
          ) {
            const currentOpen = $('.popover');
            if (currentOpen.length == 1) {
              hidePopovers();
            }

            $('body').off(`click.removepopover${actionClass}`);
          }
        });
      }

      if (sourceHotSpot.get(0).hasAttribute('aria-describedby')) {
        // We are clicking on a hotspot target that is already expanded.
        // We just close all popovers here.
        hidePopovers();
      } else {
        const selector = '[rel="popover"]'; //
        const container = false;
        debug('Making', sourceHotSpot, 'a popover');
        window.store.dispatch(window.actions.openPopup(actionClass));

        // Finally open the popover.
        $(sourceHotSpot).popover({
          selector,
          container,
          html: true,
          content: popoverContent,
          placement(context, source) {
            if ($(source).attr('data-placement')) {
              return $(source).attr('data-placement');
            } else {
              return 'bottom'; // auto was removed in Bootstrap v4
            }
          },
          trigger: 'manual',
        });
        debug('Now showing', sourceHotSpot);
        $(sourceHotSpot).popover('show');
         $('.popover').addClass(actionClass)
      }
    }
  } else {
    // and open a new modal box
    if (actionClass.substr(actionClass.length - 5) == 'guide') {
      modalToShow.data('modal').options.backdrop = 'static';
    }
    window.store.dispatch(window.actions.openPopup(actionClass));

    modalToShow.modal({
      keyboard: true,
      show: true,
    });

    if ($(`#${actionClass}_modal`).find('.nav-tabs').length > 0) {
      $(`#${actionClass}_modal .nav-tabs a:first`).tab('show');
    } else if (
      $(this).find('.modal-dialog > .modal-content > .modal-nav-tabs') != null
    ) {
      $(this)
        .find('.modal-dialog > .modal-content > .modal-nav-tabs a:first')
        .click();
    }

    // tie the tab key to the dialog box (show/hide)
    //            $('body').unbind('keydown.shift_tab');
    //              alert('binding '+actionClass);
    //            $('body').bind('keydown.shift_tab', function(){
    //              $('#' + actionClass + '_modal').modal('toggle');
    //            });

    // reset activities
    $('.Feedback').hide();
    $('.Response').show();
    $('.ShortAnswerFeedback').show();
    $('input:checkbox').attr('checked', false);

    $('.ui-widget-content').show();
    $('.DnDanswers').html(
      '<li class="placeholder">Drop your paragraphs here<br><br><br></li>',
    );
    $('.showDnDfeedback').show();
    $('.hideDnDfeedback').hide();
    $('.wasFeedback').addClass('Feedback');
    $('.DnDsource .Feedback').removeClass(
      'alert-success alert-error wasFeedback',
    );
    $('.DnDtarget .Feedback').removeClass(
      'alert-success alert-error wasFeedback',
    );
  }

  // record the opening in tincan
  // recordTinCanStatement(`${window.location}_modal_${actionClass}`,
  //     actionClass,
  //     'modal',
  //     'opened');
}
window.openModal = openModal;

// Fix popover bug in bootstrap js that doesn't reset the click state
$('body').on('hidden.bs.popover', e => {
  $(e.target).data('bs.popover').inState.click = false;
});

// this managers and sets up the events for the image maps
// it gets the modal name from the href - this has been hand coded by the user
const ImageMapManagerFn = function() {
  this.registerHandlers = function() {
    $('body').on('click', 'area', function(event) {
      // when we get a click

      if ($(this).attr('href')) {
        if (event) {
          event.returnValue = false;
        }
        event.preventDefault
          ? event.preventDefault()
          : (event.returnValue = false);
        // console.log('image map area clicked for '+$(this).attr('href'));
        const href = $(this)
          .attr('href')
          .replace('../', '')
          .replace('.html', '');
        const areaID = href.split('/').pop();
        let areaTitle = $(this).attr('alt');

        // console.log('Image map clicked. Looking for Activity for '+areaID);
        // if the name has . in the modal box is open
        if (areaID.indexOf('.') == 0) {
          // areaID = areaID.slice(1);
          areaTitle = areaID.split('.')[1];
          // console.log('Image map clicked. Opening modal box for '+areaID);

          openModal(areaTitle, { context: this });
          //  openModal(areaID); //opens a standard modal boxe
        } else if (areaID.indexOf('#') == 0) {
          // console.log('found a hash code');

          const parts = areaID.split('#');
          let target = parts[1];
          const selector = `.${parts[1]}`;

          if ($(selector).data('scene')) {
            // Use the name based selector instead if it is available
            target = $(selector).data('scene');
          }

          // console.log(target);

          $(`.scenes .${target}`).css('display', 'block'); // toggle the next one
          $(event.target)
            .closest('.scene')
            .css('display', 'none'); // turn the last one off

          $.event.trigger({
            type: 'changeScene',
            message: target,
            time: new Date(),
          });

          Cookies.set(currentCookie, target, {
            expires: 30,
          });
        }

        // stop redirecting
        // event.preventDefault();
        // if( $("html").hasClass("ie8") ) {
        // ie8 is hopeless
        // } else {
        // event.preventDefault ? event.preventDefault() : event.returnValue = false;
        // }
      }
    });
  };
};

const RangeSliderManagerFn = function() {
  this.registerHandlers = function() {
    $('.ui-slider-wrapper').css('width', '95%');
    $(document).on('click', '.ui-slider-label-ticks', e => {
      const thisTick = $(e.target).closest('.ui-slider-label-ticks')[0];
      const theseTicks = $(e.target).closest('.ui-slider-labels')[0];
      const labelIndex = $(theseTicks)
        .find('.ui-slider-label-ticks')
        .index(thisTick);
      const wrapper = $(e.target).closest('.js__mcq__slider');
      const rangeSlider = $(wrapper).find('.RangeSlider')[0];
      // const newValue = $(e.target);
      $(rangeSlider).labeledslider('value', labelIndex);
    });
    $('.RangeSliderDiv').each(function(index, value) {
      // do this for each range slider activity on the page
      // console.log( " range slider activity: " + $( this ).text() );
      const id = `#${$(this).attr('id')}`;
      // hide any feedback
      $('.Feedback', id).hide();
      // set up the slider
      const labels = new Array();
      $('.RangeSliderFeedback', id).each(function(index) {
        // do this for each range slider feedback for the activity
        // console.log('adding: '+$( this ).attr("data-label"));
        labels.push($(this).attr('data-label'));
      });
      // console.log('data-count: '+$( this ).attr("data-count"));
      $('.RangeSlider', id).labeledslider({
        max: parseInt($(this).attr('data-count')) - 1,
        tickInterval: 1,
      });
      // console.log(labels);
      $('.RangeSlider', id).labeledslider('option', 'tickLabels', labels);
      $('.RangeSlider', id).labeledslider({
        slide(event, ui) {
          // console.log('value: '+ui.value);
          $(this).attr('data-target', parseInt(ui.value) + 1);
          $(this)
            .find('.js__mcq__slider__handle')
            .attr('aria-valuenow', parseInt(ui.value) + 1);
          console.log($(this).closest('.js__mcq__slider'));
          console.log(
            $(this)
              .closest('.js__mcq__slider')
              .find('.ui-slider-labels .ui-slider-label-ticks'),
          );
          const labelText = $(
            $(this)
              .closest('.js__mcq__slider')
              .find('.ui-slider-labels .ui-slider-label-ticks')[ui.value],
          ).text();
          $(this)
            .find('.js__mcq__slider__handle')
            .attr('aria-valuetext', labelText);
        },
      });

      // this aria-valuetext="0 $"
      $('.RangeSlider', id).labeledslider({
        change(event, ui) {
          $(this).attr('data-target', parseInt(ui.value) + 1);

          const hasFeedback = $(this)
            .parent()
            .parent()
            .parent()
            .hasClass('RangeSliderButton'); // does this range find have button/

          // at this stage send the results to SCORM or xAPU
          const activitynum = $(this)
            .parent()
            .parent()
            .parent()
            .attr('data-activitynum');
          if (hasFeedback == false) {
            // send an interaction report back to the LMS if the feedback button doesn't exist
            const rawscore = $(
              `.RangeSliderFeedback${$('.RangeSlider', id).attr(
                'data-target',
              )}`,
              id,
            ).attr('data-score');
            const response = `${$(
              `.RangeSliderFeedback${$('.RangeSlider', id).attr(
                'data-target',
              )}`,
              id,
            ).attr('data-label')}  correct-${$(
              `.RangeSliderFeedback${$('.RangeSlider', id).attr(
                'data-target',
              )}`,
              id,
            ).attr('data-correct')}`;
            let activityDetails = $(this)
              .parent()
              .parent()
              .parent()
              .attr('data-SCORMdescription');
            if (activityDetails == '') {
              activityDetails = `${$('.page-title').text()} - ${$(this)
                .parent()
                .parent()
                .parent()
                .attr('data-activity-name')} - Range slider Q: ${$(
                `#SliderQuestion${activitynum}`,
              ).text()}`;
            }
            // record the result in SCORM
            // console.log("Range slider SCORM interaction... activityDetails:"+activityDetails+" rawscore:"+rawscore+" response:"+response);
            RecordSCORMinteraction(activityDetails, rawscore, response);
            recordActivity(
              $(this).attr('data-activity-name'),
              $(this).attr('data-activitynum'),
            );


           const selectedValue = $(
               `.RangeSliderFeedback${$('.RangeSlider', id).attr(
                   'data-target',
               )}`,
               id,
           ).attr('data-label')
           let isCorrect = $(
                  `.RangeSliderFeedback${$('.RangeSlider', id).attr(
                      'data-target',
                  )}`,
                  id,
              ).attr('data-correct')
           const optionId = $(
                  `.RangeSliderFeedback${$('.RangeSlider', id).attr(
                      'data-target',
                  )}`,
                  id,
              ).attr('data-option-id')
           let completion = false;
           if(isCorrect){
               isCorrect = isCorrect.toLowerCase();
               completion = isCorrect.indexOf('yes')>-1;
           }
           window.store.dispatch(window.actions.selectMCQRangeSlider(activitynum,rawscore, selectedValue,completion,optionId));

            // record result via xAPI
            // recordTinCanAction(id,activityname,question,response)
            // recordTinCanAction(`${window.location}_range${activitynum}`,
            //     `${$('.page-title').text()} - ${$(this).parent().parent().parent().attr('data-activity-name')} - Range slider activity`,
            //     $(`#SliderQuestion${activitynum}`).text(),
            //     `${response} Score: ${rawscore}`);
          } // end check to see if we're reporting this back to the LMS
        },
      });

      // set up the feedback button for this activity
      $('.RangeSliderButton', id).click(function(e) {
        // console.log('clicked range slider feedback button');
        $('.Feedback', id).hide();

        $(
          `.RangeSliderFeedback${$('.RangeSlider', id).attr('data-target')}`,
          id,
        ).show();

        // get the parameters for SCORM reporting
        const activitynum = $(this).attr('data-activitynum');
        // var minscore = $(this).attr("data-minscore"); // no longer used by the RecordSCORMinteraction function
        // var maxscore = $(this).attr("data-maxscore"); // no longer used by the RecordSCORMinteraction function
        if ($(this).attr('data-hideFromSCORM') == 'No') {
          // send an interaction report back to the LMS
          var rawscore = $(
            `.RangeSliderFeedback${$('.RangeSlider', id).attr('data-target')}`,
            id,
          ).attr('data-score');
          const response = `${$(
            `.RangeSliderFeedback${$('.RangeSlider', id).attr('data-target')}`,
            id,
          ).attr('data-label')}  correct-${$(
            `.RangeSliderFeedback${$('.RangeSlider', id).attr('data-target')}`,
            id,
          ).attr('data-correct')}`;
          let activityDetails = $(this).attr('data-SCORMdescription');
          if (activityDetails == '') {
            activityDetails = `${$('.page-title').text()} - ${$(this).attr(
              'data-activity-name',
            )} - Range slider Q: ${$(`#SliderQuestion${activitynum}`).text()}`;
          }
          // record the result in SCORM
          // console.log("Range slider SCORM interaction... activityDetails:"+activityDetails+" rawscore:"+rawscore+" response:"+response);
          RecordSCORMinteraction(activityDetails, rawscore, response);
        } // end check to see if we're reporting this back to the LMS

        // record overall progress in SCORM
        recordActivity(
          $(this).attr('data-activity-name'),
          $(this).attr('data-activitynum'),
        );

        // record result via xAPI
        // recordTinCanAction(id,activityname,question,response)
        // recordTinCanAction(`${window.location}_range${activitynum}`,
        //     `${$('.page-title').text()} - ${$(this).attr('data-activity-name')} - Range slider activity`,
        //     $(`#SliderQuestion${activitynum}`).text(),
        //     `${response} Score: ${rawscore}`);

        $(
          `.RangeSliderFeedback${$('.RangeSlider', id).attr('data-target')}`,
          id,
        ).show();

        var rawscore = $(
          `.RangeSliderFeedback${$('.RangeSlider', id).attr('data-target')}`,
          id,
        ).attr('data-score');
        if (Cookies.get($(this).attr('target')) === 'QuestionDone') {
        } else {
          window.totalscore =
            parseInt(window.totalscore, 10) + parseInt(rawscore, 10);
          let score = $(this).attr('score');
          if (score > 0) {
            score = 0;
          } // we don't want any positive scores in our section results

          const activityID = $(this)
            .closest('.isActivity')
            .attr('id');

          Cookies.set($(this).attr('id'), window.totalscore, {
            expires: 7,
            path: '/',
          });
          if (Cookies.get('finalscore')) {
            var finalscore =
              parseInt(Cookies.get('finalscore'), 10) + parseInt(rawscore, 10);
          } else {
            var finalscore = window.totalscore;
          }
          Cookies.set('finalscore', finalscore, {
            expires: 7,
            path: '/',
          });
          Cookies.set($(this).attr('target'), 'QuestionDone', {
            expires: 7,
            path: '/',
          });
        }

        // TODO? disable the slider, hide the feedback button and show a reset button
      });

      // Uses Hubspot Tether to attach the icons to the left and right dynamically
      $(this)
        .find('.js__mcq-slider__icon-left')
        .each((index, val) => {
          if ($(val).css('content')) {
            const container = $(val).closest('.RangeSlider');
            const elementId = $(val).attr('id');
            const containerId = $(container).attr('id');
            loDebug(
              'Using tether on slider left icon',
              $(val),
              elementId,
              containerId,
            );
            new Tether({
              element: `#${elementId}`,
              target: `#${containerId}`,
              attachment: 'middle right',
              targetAttachment: 'middle left',
            });
          }
        });
      $('body').on('click', '.js__mcq-slider__icon-left', function(e) {
        loDebug('rangeslider: left arrow clicked');
        const rangeslider = $(`#${$(this).attr('data-range-slider-id')}`);
        const min = $(rangeslider).labeledslider('option', 'min');
        rangeslider.labeledslider('value', min);
      });

      $(this)
        .find('.js__mcq-slider__icon-right')
        .each((index, val) => {
          if ($(val).css('content')) {
            const container = $(val).closest('.RangeSlider');
            const elementId = $(val).attr('id');
            const containerId = $(container).attr('id');
            loDebug(
              'Using tether on slider right icon',
              $(val),
              elementId,
              containerId,
            );
            new Tether({
              element: `#${elementId}`,
              target: `#${containerId}`,
              attachment: 'middle left',
              targetAttachment: 'middle right',
            });
          }
        });
      $('body').on('click', '.js__mcq-slider__icon-right', function(e) {
        loDebug('rangeslider: right arrow clicked');
        const rangeslider = $(`#${$(this).attr('data-range-slider-id')}`);

        const max = $(rangeslider).labeledslider('option', 'max');
        rangeslider.labeledslider('value', max);
      });
    });
  };
};

const ActionManagerFn = function() {
  this.registerHandlers = function() {
    const mainbody = $('body');
    if (window.ACTION_CLASSES) {
      $.each(window.ACTION_CLASSES, (index, ref) => {
        // This method means that we can dynamically change and add elements
        $(ref).addClass('trigger-common');
        $(ref).addClass(`trigger-common__2nth__${(index + 1) % 2}`);
        $(ref).addClass(`trigger-common__3nth__${(index + 1) % 3}`);
        $(ref).addClass(`trigger-common__4nth__${(index + 1) % 4}`);
        $(ref).addClass(`trigger-common__5nth__${(index + 1) % 5}`);
        $(ref).attr('tabindex',0);

        mainbody.on('click', ref, function() {
          // Specifically this pattern
          const actionClass = $(this)
            .attr('class')
            .replace(' trigger-common', '')
            .replace(' opened', '');
          if (!$(this).hasClass('opened')) $(this).addClass('opened');
          openModal(actionClass, { context: this });
        });
      });
    }

    $('body').on('click', '.nav-tabs', e => {
      // $('.tooltipAction').tooltip('hide');

      // reset activities
      $('.Feedback').hide();
      $('.Response').show();
      $('.ShortAnswerFeedback').show();
      $('input:checkbox').attr('checked', false);

      $('.ui-widget-content').show();
      $('.DnDanswers').html(
        '<li class="placeholder">Drop your paragraphs here, then drag and drop to reorder them<br><br><br></li>',
      );
      $('.showDnDfeedback').show();
      $('.hideDnDfeedback').hide();

      $('tr').removeClass('success error');
      $('td').removeClass('success error');
      $('.fb').html('');
      $('select').val('');
    });

    // multiple choice
    $('body').on('click keypress', '.mcOption', function(e) {

        let enterPressed = false
        if(e && e.type=='keypress'){
            if(e.which ==13){
                enterPressed =true;
                $(this).closest('.Choice').click()
            } else {
                return false
            }
        }
        $.event.trigger({
        type: 'progress',
        message: $(this)
          .closest('.isActivity')
          .attr('id'),
        time: new Date(),
      });

      $('body').css('cursor', 'wait');
      $(this)
        .closest('.MultipleChoiceQuestion')
        .find('.selected-choice')
        .removeClass('selected-choice');
      $(this)
        .parent()
        .addClass('selected-choice');
      $(this)
        .parent()
        .children()
        .removeClass('gh__mcq--buttons--horz__option--selected');
      //Added to remove previously selected option.
      $(this)
          .closest('.gh__block__mcq-buttons--vertical__options')
          .find('.gh__mcq--buttons--horz__option--selected')
          .removeClass('gh__mcq--buttons--horz__option--selected')
      $(this).addClass('gh__mcq--buttons--horz__option--selected');

      // my plan
      const actname = $(this).attr('data-activity-name');
      let optionscore = $(this).data('score');
      if (optionscore == 0) {
        // assume that the incorrect response has not been set to a negative
        optionscore = -1;
      } else if (optionscore > 0) {
        // mulitiple choice has the correct score set to 10 by default, but we want it at 0 for the rpl page checks
        optionscore = 0;
      } else {
        // any other is an incorrect response
        optionscore = -1;
      }

      const activityID = $(this)
        .closest('.isActivity')
        .attr('id');

      // record result via xAPI
      // recordTinCanAction(id,activityname,question,response)
      // recordTinCanAction(window.location + '_mc' + activitynum,
      //     $('.page-title').text() + ' - ' + $(this).attr("data-activity-name") + ' - MultiChoice',
      //     $('#Question' + activitynum).text(),
      //     response + ' Score: ' + rawscore);

      $(this)
        .siblings('.Feedback')
        .addClass('planFeedback');
      debug(
        'mcOption has class js__mcq__option--horz',
        $(this).hasClass('js__mcq__option--horz'),
      );
      if ($(this).hasClass('js__mcq__option--horz'))
        $(this)
          .closest('.isActivity')
          .find('.Feedback')
          .hide();

      $(`#${$(this).attr('target')}`).show(300);
        // scoring system
        // get the parameters for SCORM reporting
        const activitynum = $(this).attr('data-activitynum');
        // reset total score for new question
        if (Cookies.get(`q${activitynum}`) === 'QuestionDone') {
        } else {
          window.totalscore = 0;
          Cookies.set(`q${$(this).attr('data-activitynum')}`, 'QuestionDone', {
            expires: 7,
            path: '/',
          });
        }
        if ($(this).attr('data-hideFromSCORM') == 'No') {
          // send an interaction report back to the LMS
          const rawscore = $(this).attr('data-score');
          const response = $(this).text();
          let activityDetails = $(this).attr('data-SCORMdescription');
          if (activityDetails == '') {
            activityDetails = `${$('.page-title').text()} - ${$(this).attr(
              'data-activity-name',
            )} - MultiChoice Q: ${$(`#Question${activitynum}`).text()}`;
          }
          // record the result in SCORM
          // console.log("MC SCORM interaction... activityDetails:"+activityDetails+" rawscore:"+rawscore+" response:"+response);
          RecordSCORMinteraction(activityDetails, rawscore, response);
        } // end check to see if we're reporting this back to the LMS

        $(this)
          .closest('.radioFeedback')
          .hide();
        if ($(this).attr('t') == '0') {
          $(`#${$(this).attr('target')}`).removeClass('alert-success');
          $(`#${$(this).attr('target')}`).addClass('alert-error');
          $(`#${$(this).attr('target')}`).addClass(
            'gh__mcq-feedback--incorrect',
          );

          // RPL record incorrect responses for later reporting on prior learning pages
          // RPL var heading = $(this).closest('.isActivity').data('heading');
          // RPL if ($.inArray(heading, window.checkIncorrectActivities) == -1) {
          // RPL    window.checkIncorrectActivities.push(heading);
          // RPL }
        } else {
          $(`#${$(this).attr('target')}`).removeClass('alert-error');
          $(`#${$(this).attr('target')}`).addClass('alert-success');
          $(`#${$(this).attr('target')}`).addClass('gh__mcq-feedback--correct');
        }
        // console.log($(this).closest('.MultipleChoiceQuestion').attr('class'));

        // set a cookie to indicate whether the answer has been selected or not
        // if not, store the score into a cookie and set the option as selected
        if (
          Cookies.get(
            $(this).attr('data-activitynum') +
              $(this)
                .children('input')
                .attr('id'),
          ) === 'QuestionDone'
        ) {
        } else {
          window.totalscore =
            parseInt(window.totalscore, 10) +
            parseInt($(this).attr('data-score'), 10);
          Cookies.set($(this).attr('data-activitynum'), window.totalscore, {
            expires: 7,
            path: '/',
          });
          let finalscore = window.totalscore;
          if (Cookies.get('finalscore')) {
            finalscore =
              parseInt(Cookies.get('finalscore'), 10) +
              parseInt($(this).attr('data-score'), 10);
          }
          Cookies.set('finalscore', finalscore, {
            expires: 7,
            path: '/',
          });
          Cookies.set(
            $(this).attr('data-activitynum') +
              $(this)
                .children('input')
                .attr('id'),
            'QuestionDone',
            {
              expires: 7,
              path: '/',
            },
          );
          const questionID = `q${$(this).attr('data-activitynum')}`;
          let currentQuestion = {};
          if (Cookies.get('scoreAll')) {
            currentQuestion = Cookies.getJSON('scoreAll');
          }

          currentQuestion[`q${$(this).attr('data-activitynum')}`] =
            window.totalscore;
          // var scoreItem = JSON.stringify(currentQuestion);
          Cookies.set('scoreAll', currentQuestion, {
            expires: 7,
            path: '/',
          });
        }
        // set feedback background color
        if ($(this).attr('data-score') == '10') {
          $(this)
            .siblings('.Feedback')
            .addClass('score10');
        }
        if ($(this).attr('data-score') == '9') {
          $(this)
            .siblings('.Feedback')
            .addClass('score9');
        }
        if ($(this).attr('data-score') == '8') {
          $(this)
            .siblings('.Feedback')
            .addClass('score8');
        }
        if ($(this).attr('data-score') == '7') {
          $(this)
            .siblings('.Feedback')
            .addClass('score7');
        }
        if ($(this).attr('data-score') == '6') {
          $(this)
            .siblings('.Feedback')
            .addClass('score6');
        }
        if ($(this).attr('data-score') == '5') {
          $(this)
            .siblings('.Feedback')
            .addClass('score5');
        }
        if ($(this).attr('data-score') == '4') {
          $(this)
            .siblings('.Feedback')
            .addClass('score4');
        }
        if ($(this).attr('data-score') == '3') {
          $(this)
            .siblings('.Feedback')
            .addClass('score3');
        }
        if ($(this).attr('data-score') < '3') {
          $(this)
            .siblings('.Feedback')
            .addClass('score2orless');
        }
        // end of score coloring
        // record overall progress in SCORM
        recordActivity(
          $(this).attr('data-activity-name'),
          $(this).attr('data-activitynum'),
        );
        // record result via xAPI
        // recordTinCanAction(id,activityname,question,response)
        // recordTinCanAction(window.location + '_mc' + activitynum,
        //     $('.page-title').text() + ' - ' + $(this).attr("data-activity-name") + ' - MultiChoice',
        //     $('#Question' + activitynum).text(),
        //     response + ' Score: ' + rawscore);

        // show feedback (if there is any)
        if (
          $(`#${$(this).attr('target')}`)
            .text()
            .trim() != ''
        ) {
          $(`#${$(this).attr('target')}`).show(300);
        }

      $('body').css('cursor', 'auto');
    });

    // self assessment
    $('body').on('click', '.saCheckbox', function(e) {
      if ($($(this)).is(':checked')) {
        // console.log($(this).parent().find(".saFeedback").text());
        $(this)
          .parent()
          .find('.saAnswerFeedback')
          .addClass('Feedback');
        if ($(this).attr('t') == '0') {
          $(this)
            .parent()
            .find('.saFeedback')
            .text('No');
        } else {
          $(this)
            .parent()
            .find('.saFeedback')
            .removeClass('text-error');
          $(this)
            .parent()
            .find('.saFeedback')
            .addClass('text-success');
          $(this)
            .parent()
            .find('.saFeedback')
            .text('Yes');
        }
        window.currentscore += parseFloat($(this).attr('p')); // update the current score for the question
        window.feedback = $(this).attr('fb');
      } else {
        // the checkbox was checked, now it's been unchecked
        $(this)
          .parent()
          .find('.saAnswerFeedback')
          .removeClass('Feedback');
        if ($(this).attr('t') == '0') {
          $(this)
            .parent()
            .find('.saFeedback')
            .text(' ');
        } else {
          $(this)
            .parent()
            .find('.saFeedback')
            .removeClass('text-success');
          $(this)
            .parent()
            .find('.saFeedback')
            .addClass('text-error');
          $(this)
            .parent()
            .find('.saFeedback')
            .text('You should have selected this option &uarr;');
        }
        window.currentscore -= parseFloat($(this).attr('p')); // undo the previous change to the score for this question
      }
    });

    // set up the new 'multi option' features
    $('body').on('click', '.featureSelect', e => {
      e.stopPropagation();
      e.preventDefault();
    });
    $('.featureOption').each(function(index) {
      const target = $(this)
        .parent()
        .attr('data-target');
      // console.log( index + ": " + $( this ).text() + ' target: '+target );
      if (target == $(this).text()) {
        $(this).attr('value', 'success');
      } else {
        $(this).attr('value', 'error');
      }
      $(this).on('click', e => {
        e.stopPropagation();
        e.preventDefault();
      });
    });
    $('.FeaturesFeedback').each(function() {
      // do this for each features activity on the page
      const id = `#${$(this).attr('featuresid')}`;
      // console.log('hiding feedback for id: '+"#"+$( this ).attr("featuresid"));// do the SCORM reporting thing
      const activitynum = $(this).attr('data-activitynum');

      const activityDetails = $(this).attr('data-SCORMdescription');
      const activityname = $(this).attr('data-activity-name');
      let sendscorm = false;
      if ($(this).attr('data-hideFromSCORM') == 'No') {
        // send an interaction report back to the LMS
        sendscorm = true;
      }
      // hide any feedback
      $('.Feedback', id).hide();
      $('body').on('click', `${id} .FeaturesFeedback`, e => {
        $('td', id).removeClass('success error');
        $('.Feedback', id).show();
        $('select', id).each(function(index) {
          $(this)
            .closest('td')
            .addClass($(this).val());
          let response = $('option:selected', this).text();
          let rawscore;
          let fb;
          if ($(this).val() == 'success') {
            rawscore = $(this).attr('data-score');
            if (rawscore == '0') {
              fb = "<strong class='alert-success'>Correct</strong>";
            } else {
              fb = `<strong class='alert-success'>Correct ${rawscore}</strong>`;
            }
            response += ' (correct)';
            if (
              Cookies.get(
                $(this)
                  .children('.featureOption')
                  .attr('data-source'),
              ) === 'QuestionDone'
            ) {
            } else {
              window.totalscore =
                parseInt(window.totalscore, 10) +
                parseInt($(this).attr('data-score'), 10);
              let score = $(this).attr('score');
              if (score > 0) {
                score = 0;
              } // we don't want any positive scores in our section results

              const activityID = $(this)
                .closest('.isActivity')
                .attr('id');

              Cookies.set($(this).attr('data-activitynum'), window.totalscore, {
                expires: 7,
                path: '/',
              });
              let finalscore = window.totalscore;
              if (Cookies.get('finalscore')) {
                finalscore =
                  parseInt(Cookies.get('finalscore'), 10) +
                  parseInt(rawscore, 10);
              }
              Cookies.set('finalscore', finalscore, {
                expires: 7,
                path: '/',
              });
              Cookies.set(
                $(this)
                  .children('.featureOption')
                  .attr('data-source'),
                'QuestionDone',
                {
                  expires: 7,
                  path: '/',
                },
              );
            }
          } else {
            fb = "<strong class='alert-error'>Incorrect</strong>";
            rawscore = 0;
            response += ' (incorrect)';

            Cookies.set(
              $(this)
                .children('.featureOption')
                .attr('data-source'),
              'QuestionDone',
              {
                expires: 7,
                path: '/',
              },
            );
          }
          // $(this).parent().children('span').html(fb);

          if (sendscorm == true) {
            let TheseActivityDetails;
            // record the result in SCORM
            if (activityDetails == '') {
              const q = $(`#Q${$(this).attr('id')}`).text();
              const TheseActivityDetails = `${$(
                '.page-title',
              ).text()} - ${activityname} - Features Q: ${q}`;
            }
            // console.log("MC SCORM interaction... activityDetails:"+TheseActivityDetails+" rawscore:"+rawscore+" response:"+response);
            RecordSCORMinteraction(TheseActivityDetails, rawscore, response);
          }

          // record overall progress in SCORM
          recordActivity(activityname, activitynum);

          // record result via xAPI
          // recordTinCanAction(id,activityname,question,response)
          // recordTinCanAction(`${window.location}_f${activitynum}`,
          //     `${$('.page-title').text()} - ${activityname} - Features`,
          //     q,
          //     `${response} Score: ${rawscore}`);
        });
      });
    });

    // exit webpage
    $('a[href$="exit/"]')
      .find('button')
      .on('click', e => {
        event.preventDefault();
        // var wsh=new ActiveXObject("WScript.Shell");
        // wsh.SendKeys("ctrl"+"w");
        window.opener = null;
        window.open('', '_self', '');
        window.close();
      });
  };
};

const BandwidthManagerFn = function() {
  this.registerHandlers = function() {
    $('body').on('click', '.textandimage', event => {
      // when we get a click
      Cookies.set('bandwidth', 'textandimage', {
        expires: 60,
        path: '/',
      });
    });
    $('body').on('click', '.low', event => {
      // when we get a click
      Cookies.set('bandwidth', 'low', {
        expires: 60,
        path: '/',
      });
    });
    $('body').on('click', '.medium', event => {
      // when we get a click
      Cookies.set('bandwidth', 'medium', {
        expires: 60,
        path: '/',
      });
    });

    $('body').on('click', '.high', event => {
      // when we get a click
      Cookies.set('bandwidth', 'high', {
        expires: 60,
        path: '/',
      });
    });
  };
};

/**
 * jQuery Shuffle (http://mktgdept.com/jquery-shuffle)
 * A jQuery plugin for shuffling a set of elements
 *
 * v0.0.1 - 13 November 2009
 *
 * Copyright (c) 2009 Chad Smith (http://twitter.com/chadsmith)
 * Dual licensed under the MIT and GPL licenses.
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.opensource.org/licenses/gpl-license.php
 *
 * Shuffle elements using: $(selector).shuffle() or $.shuffle(selector)
 *
 * */
(function(d) {
  d.fn.shuffle = function(c) {
    c = [];
    return this.each(function() {
      c.push(d(this).clone(true));
    }).each((a, b) => {
      d(b).replaceWith(c[(a = Math.floor(Math.random() * c.length))]);
      c.splice(a, 1);
    });
  };
  d.shuffle = function(a) {
    return d(a).shuffle();
  };
})(jQuery);

function makeSCORMlinks() {
  // create links on the home page to any media that's on a modal page so that it gets picked up by the SCORM export routine
  // console.log('looking for hidden SCORM links');
  let linklist = '';
  $('.hiddenmedialink').each(function(index) {
    // console.log( 'hidden link found '+ index + ": " + $( this ).attr('href') );
    linklist += `<a tabindex="-1" href="${$(this).attr('href')}">.</a>`;
  });
  $('#hiddenmedialinks').html(linklist);

  // also add a listener for any clicks on buttons or links with the SCORMcompleted class on them
  $('body').on('click', '.SCORMcompleted, .Completed, .completed', () => {
    window.store.dispatch(window.actions.setCourseComplete());
  });
  $('body').on('click', '.js__recordCompletionAndClose', () => {
    window.store.dispatch(window.actions.setCourseComplete());
    window.store.dispatch(window.actions.closeWindow());
  });
}

export function recordTinCanAction(
  id,
  activityname,
  question,
  answer,
  rawscore,
) {
  const a = typeof score !== 'undefined' ? score : 0;
  id = id.replace(/#/g, '_');
  console.warn('A old style xAPI statement is being sent');
  if (window.glasshouseTinCan) {
    let output;
    if (answer.length > 0) {
      output = {
        actor: {
          mbox: `mailto:${window.glasshouseEmail}`,
          name: window.glasshouseUserName,
          objectType: 'Agent',
        },
        verb: {
          id: 'http://adlnet.gov/expapi/verbs/answered',
          display: {
            'en-US': 'answered',
          },
        },
        object: {
          id,
          objectType: 'Activity',
          definition: {
            name: {
              'en-US': activityname,
            },
            // "description": {"en-US": "On this map, please mark Franklin, TN"},
            description: {
              'en-US': question,
            },
            // "type": "http://adlnet.gov/expapi/activities/cmi.interaction",
            type: 'http://adlnet.gov/expapi/activities/interaction',
            interactionType: 'other',
            // "correctResponsesPattern": Array()
          },
        },
        result: {
          // "success": "", // true, false
          response: answer,
          score: {
            raw: rawscore,
          },
        },
      };
    } else {
      // no answer provided
      output = {
        actor: {
          mbox: `mailto:${window.glasshouseEmail}`,
          name: window.glasshouseUserName,
          objectType: 'Agent',
        },
        verb: {
          id: 'http://adlnet.gov/expapi/verbs/answered',
          display: {
            'en-US': 'answered',
          },
        },
        object: {
          id,
          objectType: 'Activity',
          definition: {
            name: {
              'en-US': activityname,
            },
            // "description": {"en-US": "On this map, please mark Franklin, TN"},
            description: {
              'en-US': question,
            },
            // "type": "http://adlnet.gov/expapi/activities/cmi.interaction",
            type: 'http://adlnet.gov/expapi/activities/interaction',
            interactionType: 'other',
          },
        },
      };
    }
    // console.log(output);
    window.glasshouseTinCan.sendStatement(output);
  } else {
    // console.log('no tincan endpoint. Set one via the glasshouse site settings - Experience API tab');
  }
}
window.recordTinCanAction = recordTinCanAction;

function recordTinCanStatement(id, activityname, verb, object) {
  id = id.replace(/#/g, '_');

  if (window.glasshouseTinCan) {
    const output = {
      actor: {
        mbox: `mailto:${window.glasshouseEmail}`,
        name: window.glasshouseUserName,
        objectType: 'Agent',
      },
      verb: {
        id: `http://adlnet.gov/expapi/verbs/${verb}`,
        display: {
          'en-US': verb,
        },
      },
      object: {
        id,
        objectType: 'Activity',
        definition: {
          name: {
            'en-US': activityname,
          },
          description: {
            'en-US': activityname,
          },
          type: 'http://adlnet.gov/expapi/activities/cmi.interaction',
          interactionType: 'other',
        },
      },
    };
    if (object)
      output.object.definition.correctResponsesPattern = Array(object);
    // if (DEBUGGING) console.log(output);
    window.glasshouseTinCan.sendStatement(output);
  } else {
    // console.log('no tincan endpoint. Set one via the glasshouse site settings - Experience API tab');
  }
}

export function recordActivity(activityname, id) {
  // SCORM is now being tracked on an activity by activity basis so that we can track progress on sequence pages too (PS 10 Nov 2014)
  // get progress from a cookie (if there is one for this page)
  let ActivitiesDone = [];
  if (Cookies.get('ActivitiesDone') != null) {
    ActivitiesDone = Cookies.getJSON('ActivitiesDone');
  }
  // console.log('ActivitiesDone array: '+ActivitiesDone);
  const found = $.inArray(id, ActivitiesDone);
  if (found < 0) {
    // this is the first time we've done this activity
    // record that the activity is completed
    ActivitiesDone.push(id);
    // console.log('ActivitiesDone: '+ActivitiesDone);
    Cookies.set('ActivitiesDone', ActivitiesDone, {
      expires: 7,
      path: '/',
    });
    const title = $('#pagetitle')
      .text()
      .replace(/[^a-zA-Z0-9]/g, '_');
    // console.log("$('#pagetitle').text(): "+$('#pagetitle').text());
    // console.log('title: '+title);
    // SCORM is now being tracked on an activity by activity basis so that we can track progress on sequence pages too (PS 10 Nov 2014)
    // update SCORM score
    const score =
      Math.round(ActivitiesDone.length / parseInt(window.activitiesOnPage)) *
      100;
    // console.log('Score now: '+score);
    // console.log('activity name: '+activityname);
    RecordTest(score, activityname);
    // stash progress in a cookie so we can show it on the main page menu
    if (typeof Cookies.get(`${title}_ActivitesCompleted`) === 'undefined') {
      Cookies.set(`${title}_ActivitesCompleted`, 1, {
        expires: 7,
        path: '/',
      }); // for tracking completed worked examples
    } else {
      Cookies.set(
        `${title}_ActivitesCompleted`,
        parseInt(Cookies.get(`${title}_ActivitesCompleted`)) + 1,
        {
          expires: 7,
          path: '/',
        },
      );
    }
  } else {
  }
}
window.recordActivity = recordActivity;

function showFeatureFeedback(
  featureID,
  FeatureFeedbackIncorrect,
  FeatureFeedback,
) {
  // show feedback for individual feature (dropdown) when selected
  // console.log($("#feedback4"+featureID));
  $(`#feedback4${featureID}`)
    .children('td')
    .removeClass('alert-success alert-error');
  $(`#feedback4${featureID}`)
    .children('td')
    .addClass(
      `${$(`#${featureID}`).val()} ${$(`#${featureID}`).val() == 'success'}`
        ? 'alert-success'
        : 'alert-error',
    );
  if ($(`#${featureID}`).val() == 'error') {
    $(`#feedback4${featureID}`)
      .children('td')
      .removeClass('alert-success');
    $(`#feedback4${featureID}`)
      .children('td')
      .addClass('alert-error');
    if (FeatureFeedbackIncorrect == '') {
      // use the default
      $(`#feedback4${featureID}`)
        .children('td')
        .html('<p>Try again</p>');
    } else {
      // user provided error message
      $(`#feedback4${featureID}`)
        .children('td')
        .html(`<p>${FeatureFeedbackIncorrect}</p>`);
    }
  } else {
    // success
    $(`#feedback4${featureID}`)
      .children('td')
      .html(
        `<p class="ffbCorrect alert-success">Correct</p><p>${FeatureFeedback}</p>`,
      );
  }
  $(`#feedback4${featureID}`)
    .hide()
    .fadeIn();
}
window.showFeatureFeedback = showFeatureFeedback;



// WEBPACK FOOTER //
// Glasshouse/Core/js/lobuilder.jquery.js